(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories-height-range-v2"] && !Shopify.designMode) return;
  try {
    
  // accessories-height-range-v2: custom variant picker + dialog logic
  (() => {
    const initializedSections = new WeakSet();
    const mobileMediaQuery = window.matchMedia('(max-width: 699px)');
    const interactionCycle = {
      default: 'open',
      open: 'restore',
      restore: 'default',
    };

    const getSlideTriggers = (section) => Array.from(section.querySelectorAll('[data-slide-trigger]'));
    const getInteractionControls = (section) => Array.from(section.querySelectorAll('[data-interaction-control]'));
    const getInteractionItems = (section) => Array.from(section.querySelectorAll('[data-interaction-item]'));

    const syncTabsNavState = (section) => {
      const triggers = getSlideTriggers(section);
      const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
      const prevButton = section.querySelector('[data-tabs-prev]');
      const nextButton = section.querySelector('[data-tabs-next]');

      if (prevButton) {
        prevButton.disabled = activeIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = activeIndex === -1 || activeIndex >= triggers.length - 1;
      }
    };

    const scrollActiveTabIntoView = (section) => {
      const activeTrigger = section.querySelector('[data-slide-trigger].is-active');

      if (activeTrigger && typeof activeTrigger.scrollIntoView === 'function') {
        activeTrigger.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    };

    const resetInteractionsToDefault = (section, options = {}) => {
      const { restartVideo = false } = options;
      const controls = getInteractionControls(section);

      if (!controls.length) {
        return;
      }

      controls.forEach((button) => {
        setInteractionState(section, button.dataset.interactionControl, 'default');
      });

      const firstInteractionId = section.dataset.defaultInteraction || controls[0]?.dataset.interactionControl || '';
      section.dataset.activeInteraction = firstInteractionId;
      syncInteractionDisplay(section, { restartVideo });
    };

    // 按当前 slide 的 data-available-interactions 动态显隐 Interaction 按钮/胶囊
    const syncInteractionAvailability = (section) => {
      const controls = getInteractionControls(section);

      if (!controls.length) {
        return;
      }

      const panel = section.querySelector('[data-slide-panel].is-active');
      const available = ((panel && panel.dataset.availableInteractions) || '')
        .split(/\s+/)
        .filter(Boolean);
      let firstVisibleId = '';

      controls.forEach((button) => {
        const isAvailable = available.includes(button.dataset.interactionControl);
        button.hidden = !isAvailable;

        if (isAvailable && !firstVisibleId) {
          firstVisibleId = button.dataset.interactionControl;
        }
      });

      const stack = section.querySelector('.accessories-height-range__controls-stack');

      if (stack) {
        stack.hidden = !firstVisibleId;
      }

      // 当前选中的 interaction 在该 slide 不可用时，切到第一个可用项并复位 default
      const activeId = section.dataset.activeInteraction || '';

      if (!available.includes(activeId)) {
        controls.forEach((button) => {
          setInteractionState(section, button.dataset.interactionControl, 'default');
        });
        section.dataset.activeInteraction = firstVisibleId;
        syncInteractionDisplay(section, { restartVideo: false });
      }
    };

    const activateSlide = (section, slideKey, options = {}) => {
      const { shouldScrollTab = true, resetInteractions = true } = options;
      const panels = Array.from(section.querySelectorAll('[data-slide-panel]'));
      const triggers = getSlideTriggers(section);
      const currentSlideKey =
        section.querySelector('[data-slide-trigger].is-active')?.dataset.slideTrigger ||
        section.querySelector('[data-slide-panel].is-active')?.dataset.slidePanel ||
        '';

      panels.forEach((panel) => {
        const isActive = panel.dataset.slidePanel === slideKey;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.slideTrigger === slideKey;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (resetInteractions && currentSlideKey !== slideKey) {
        resetInteractionsToDefault(section, { restartVideo: true });
      }

      if (shouldScrollTab) {
        scrollActiveTabIntoView(section);
      }

      syncTabsNavState(section);
      syncInteractionAvailability(section);
      centerWideStageScroller(section);
      syncWideScrollProgress(section);
    };

    const getSlideKeys = (section) => getSlideTriggers(section).map((trigger) => trigger.dataset.slideTrigger);

    const ensureInteractionStateStore = (section) => {
      if (!section._interactionStates) {
        section._interactionStates = {};
      }

      return section._interactionStates;
    };

    const getInteractionState = (section, interactionId) => {
      const store = ensureInteractionStateStore(section);
      return store[interactionId] || 'default';
    };

    const setInteractionState = (section, interactionId, state) => {
      const store = ensureInteractionStateStore(section);
      store[interactionId] = state;
    };

    const syncInteractionDisplay = (section, options = {}) => {
      const { restartVideo = false } = options;
      const activeInteractionId = section.dataset.activeInteraction || '';
      const activeInteractionState = activeInteractionId ? getInteractionState(section, activeInteractionId) : 'default';
      const loopEnabled = section.dataset.mediaLoopEnabled === 'true';
      let hasVisibleMedia = false;

      getInteractionControls(section).forEach((button) => {
        const isActive = button.dataset.interactionControl === activeInteractionId;
        const buttonState = isActive ? activeInteractionState : 'default';
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.dataset.interactionState = buttonState;
      });

      getInteractionItems(section).forEach((item) => {
        const interactionId = item.dataset.interactionItem;
        // 纯默认态（无 Open/Restore 视频）的 interaction 为静态层：常驻显示默认媒体，不参与互斥激活
        const isStatic = item.dataset.interactionMode === 'static';
        const isItemActive = !isStatic && interactionId === activeInteractionId;
        const isVisibleSlide = item.closest('[data-slide-panel]')?.classList.contains('is-active');
        item.hidden = isStatic ? false : !isItemActive;
        item.classList.toggle('is-active', isItemActive);

        item.querySelectorAll('[data-interaction-state-panel]').forEach((statePanel) => {
          const isEmpty = statePanel.classList.contains('is-empty');
          const isStateActive = isStatic
            ? statePanel.dataset.interactionStatePanel === 'default' && !isEmpty
            : isItemActive && statePanel.dataset.interactionStatePanel === activeInteractionState && !isEmpty;
          const videos = Array.from(statePanel.querySelectorAll('video'));
          const hasMobileVariant = videos.some((v) => v.classList.contains('accessories-height-range__interaction-media--mobile'));

          statePanel.hidden = !isStateActive;

          if (isStateActive) {
            hasVisibleMedia = true;
          }

          videos.forEach((video) => {
            video.loop = loopEnabled;
            video.muted = true;
            video.playsInline = true;

            // 双端素材：该 state 有手机端视频时仅播放当前断点版本；无手机端视频时桌面端视频双端播放（回退）
            const isMobileVariant = video.classList.contains('accessories-height-range__interaction-media--mobile');
            const matchesBreakpoint = hasMobileVariant ? isMobileVariant === mobileMediaQuery.matches : true;

            if (isStateActive && isVisibleSlide && matchesBreakpoint) {
              if (restartVideo) {
                try {
                  video.currentTime = 0;
                } catch (error) {
                }
              }

              const playPromise = video.play();

              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();

              if (restartVideo) {
                try {
                  video.currentTime = 0;
                } catch (error) {
                }
              }
            }
          });
        });
      });

      const emptyState = section.querySelector('[data-interaction-empty]');

      if (emptyState) {
        emptyState.hidden = hasVisibleMedia || !activeInteractionId;
      }

      section.querySelectorAll('[data-slide-panel][data-hide-hotspots-on-interaction]').forEach((panel) => {
        panel.classList.toggle('is-interaction-active', activeInteractionState !== 'default');
      });
    };

    const activateInteraction = (section, interactionId) => {
      if (!interactionId) {
        return;
      }

      const controls = getInteractionControls(section);

      if (!controls.length) {
        return;
      }

      const currentInteractionId = section.dataset.activeInteraction || '';
      const isSwitchingInteraction = currentInteractionId && currentInteractionId !== interactionId;

      if (isSwitchingInteraction) {
        controls.forEach((button) => {
          const controlId = button.dataset.interactionControl;
          setInteractionState(section, controlId, 'default');
        });

        setInteractionState(section, interactionId, 'open');
      } else {
        const currentState = getInteractionState(section, interactionId);
        const nextState = interactionCycle[currentState] || 'default';
        setInteractionState(section, interactionId, nextState);
      }

      section.dataset.activeInteraction = interactionId;
      syncInteractionDisplay(section, { restartVideo: true });
    };

    const initControls = (section) => {
      const controls = getInteractionControls(section);

      if (!controls.length) {
        return;
      }

      controls.forEach((button) => {
        setInteractionState(section, button.dataset.interactionControl, 'default');
        button.addEventListener('click', () => {
          activateInteraction(section, button.dataset.interactionControl);
        });
      });

      const firstVisibleControl = controls.find((button) => !button.hidden);
      const defaultVisibleControl = controls.find(
        (button) => button.dataset.interactionControl === section.dataset.defaultInteraction && !button.hidden
      );
      const firstInteractionId = (defaultVisibleControl || firstVisibleControl || controls[0])?.dataset.interactionControl || '';

      if (firstInteractionId) {
        section.dataset.activeInteraction = firstInteractionId;
        syncInteractionDisplay(section, { restartVideo: true });
      }

    };

    const closeVariantPicker = (picker) => {
      if (!picker) {
        return;
      }

      picker.classList.remove('is-open');

      const list = picker.querySelector('[data-variant-list]');
      const trigger = picker.querySelector('[data-variant-trigger]');

      if (list) {
        list.hidden = true;
      }

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    };

    const closeAllVariantPickers = (root = document) => {
      root.querySelectorAll('[data-variant-picker].is-open').forEach(closeVariantPicker);
    };

    const initDialogs = (section) => {
      section.querySelectorAll('[data-dialog-target]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = section.querySelector(`#${button.dataset.dialogTarget}`);

          if (dialog && typeof dialog.showModal === 'function') {
            dialog.showModal();
          }
        });
      });

      section.querySelectorAll('dialog.accessories-height-range__dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            dialog.close();
          }
        });

        dialog.addEventListener('close', () => {
          closeAllVariantPickers(dialog);
        });
      });
    };

    const initVariantPickers = (section) => {
      section.querySelectorAll('[data-variant-picker]').forEach((picker) => {
        const trigger = picker.querySelector('[data-variant-trigger]');
        const list = picker.querySelector('[data-variant-list]');
        const options = Array.from(list.querySelectorAll('[role="option"]'));
        const input = picker.querySelector('input[name="id"]');
        const valueEl = picker.querySelector('[data-selected-value]');
        const form = picker.closest('form');
        const priceEl = form?.querySelector('.accessories-height-range__dialog-price');
        const submitBtn = form?.querySelector('.accessories-height-range__dialog-submit');
        const card = picker.closest('.accessories-height-range__dialog-card');
        const imageEl = card?.querySelector('.accessories-height-range__dialog-image');

        const setOpen = (isOpen) => {
          picker.classList.toggle('is-open', isOpen);
          list.hidden = !isOpen;
          trigger.setAttribute('aria-expanded', String(isOpen));

          if (isOpen) {
            const selected = list.querySelector('[aria-selected="true"]') || options[0];
            if (selected) {
              selected.focus();
            }
          } else {
            trigger.focus();
          }
        };

        const updateSelection = (option) => {
          options.forEach((opt) => opt.setAttribute('aria-selected', 'false'));
          option.setAttribute('aria-selected', 'true');
          valueEl.textContent = option.textContent.trim();
          input.value = option.dataset.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));

          if (priceEl) {
            priceEl.textContent = option.dataset.price || priceEl.textContent;
          }

          if (imageEl && option.dataset.image) {
            imageEl.src = option.dataset.image;

            if (option.dataset.imageSrcset) {
              imageEl.srcset = option.dataset.imageSrcset;
            } else {
              imageEl.removeAttribute('srcset');
            }

            if (option.dataset.imageAlt) {
              imageEl.alt = option.dataset.imageAlt;
            }
          }

          if (submitBtn) {
            const available = option.dataset.available === 'true';
            submitBtn.disabled = !available;
            submitBtn.classList.toggle('is-sold-out', !available);
            const addLabel = submitBtn.dataset.addLabel || 'Add to Cart';
            const soldOutLabel = submitBtn.dataset.soldOutLabel || 'Sold out';
            submitBtn.textContent = available ? addLabel : soldOutLabel;
          }
        };

        trigger.addEventListener('click', (event) => {
          event.stopPropagation();

          const willOpen = !picker.classList.contains('is-open');

          section.querySelectorAll('[data-variant-picker].is-open').forEach((other) => {
            if (other !== picker) {
              closeVariantPicker(other);
            }
          });

          setOpen(willOpen);
        });

        list.addEventListener('click', (event) => {
          const option = event.target.closest('[role="option"]');
          if (!option) {
            return;
          }

          updateSelection(option);
          setOpen(false);
        });

        list.addEventListener('keydown', (event) => {
          const current = list.querySelector('[role="option"]:focus') || list.querySelector('[aria-selected="true"]');
          let next = null;

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            next = current?.nextElementSibling || options[0];
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            next = current?.previousElementSibling || options[options.length - 1];
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (current) {
              updateSelection(current);
              setOpen(false);
            }
          } else if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false);
          }

          if (next && next.matches('[role="option"]')) {
            next.focus();
          }
        });
      });
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-variant-picker].is-open')) {
        closeAllVariantPickers();
      }
    });

    const initChooseModelLink = (section) => {
      section.querySelectorAll('[data-scroll-top]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const hash = link.getAttribute('href');
          const target = hash ? document.querySelector(hash) : null;

          if (!target) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });
    };

    const initTabsNavigation = (section) => {
      const triggers = getSlideTriggers(section);
      const tabsScroller = section.querySelector('[data-tabs-scroller]');
      const prevButton = section.querySelector('[data-tabs-prev]');
      const nextButton = section.querySelector('[data-tabs-next]');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
          const previousTrigger = activeIndex > 0 ? triggers[activeIndex - 1] : null;

          if (previousTrigger) {
            activateSlide(section, previousTrigger.dataset.slideTrigger);
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
          const nextTrigger = activeIndex > -1 && activeIndex < triggers.length - 1 ? triggers[activeIndex + 1] : null;

          if (nextTrigger) {
            activateSlide(section, nextTrigger.dataset.slideTrigger);
          }
        });
      }

      if (tabsScroller) {
        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let dragged = false;
        let suppressClick = false;

        tabsScroller.addEventListener('pointerdown', (event) => {
          if (event.pointerType == 'mouse' && event.button !== 0) {
            return;
          }

          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = tabsScroller.scrollLeft;
          dragged = false;
          suppressClick = false;
        });

        tabsScroller.addEventListener('pointermove', (event) => {
          if (pointerId !== event.pointerId) {
            return;
          }

          const deltaX = event.clientX - startX;

          if (Math.abs(deltaX) > 8) {
            if (!dragged) {
              if (typeof tabsScroller.setPointerCapture === 'function') {
                tabsScroller.setPointerCapture(pointerId);
              }

              suppressClick = true;
            }

            dragged = true;
          }

          if (dragged) {
            tabsScroller.scrollLeft = startScrollLeft - deltaX;
          }
        });

        const endDrag = (event) => {
          if (pointerId !== event.pointerId) {
            return;
          }

          if (typeof tabsScroller.hasPointerCapture === 'function' && tabsScroller.hasPointerCapture(pointerId)) {
            tabsScroller.releasePointerCapture(pointerId);
          }

          suppressClick = dragged;
          pointerId = null;
          dragged = false;
        };

        tabsScroller.addEventListener('pointerup', endDrag);
        tabsScroller.addEventListener('pointercancel', endDrag);

        tabsScroller.addEventListener('click', (event) => {
          if (suppressClick) {
            event.preventDefault();
            event.stopPropagation();
            suppressClick = false;
          }
        }, true);
      }

      syncTabsNavState(section);
    };

    // ===== 16:9 横滑模式（block 级：仅当前激活 slide 为 wide 时启用） =====
    const isPanelWide = (panel) => Boolean(panel && panel.hasAttribute('data-mobile-wide'));
    const getActivePanel = (section) => section.querySelector('[data-slide-panel].is-active');

    const syncWideScrollProgress = (section) => {
      const progress = section.querySelector('[data-scroll-progress]');

      if (!progress) {
        return;
      }

      const activePanel = getActivePanel(section);
      const scroller = activePanel ? activePanel.querySelector('.accessories-height-range__stage-media') : null;

      if (!isPanelWide(activePanel) || !scroller) {
        progress.classList.remove('is-visible');
        return;
      }

      progress.classList.add('is-visible');

      const thumb = progress.querySelector('[data-scroll-progress-thumb]');

      if (!thumb) {
        return;
      }

      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const fraction = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      const progressWidth = progress.clientWidth;
      const thumbWidth = scroller.scrollWidth > 0
        ? (progressWidth * scroller.clientWidth) / scroller.scrollWidth
        : progressWidth;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${fraction * (progressWidth - thumbWidth)}px)`;
    };

    // 默认居中显示中间 1:1；hidden 面板无布局，等激活时再居中
    const centerWideStageScroller = (section, { force = false } = {}) => {
      const panel = getActivePanel(section);

      if (!isPanelWide(panel)) {
        return;
      }

      const scroller = panel.querySelector('.accessories-height-range__stage-media');

      if (!panel || !scroller || scroller.scrollWidth === 0) {
        return;
      }

      if (!force && panel.dataset.wideScrollerCentered === 'true') {
        return;
      }

      scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) / 2;
      panel.dataset.wideScrollerCentered = 'true';
    };

    const initWideScrollers = (section) => {
      if (!section.querySelector('[data-mobile-wide]')) {
        return;
      }

      section.querySelectorAll('[data-mobile-wide] .accessories-height-range__stage-media').forEach((scroller) => {
        let rafId = null;

        scroller.addEventListener('scroll', () => {
          if (rafId !== null) {
            return;
          }

          rafId = requestAnimationFrame(() => {
            rafId = null;
            syncWideScrollProgress(section);
          });
        }, { passive: true });
      });

      centerWideStageScroller(section);
      syncWideScrollProgress(section);

      // 视口宽度变化（旋转屏等）后重新居中并同步进度条
      let resizeTimer = null;

      window.addEventListener('resize', () => {
        if (resizeTimer !== null) {
          window.clearTimeout(resizeTimer);
        }

        resizeTimer = window.setTimeout(() => {
          resizeTimer = null;
          section.querySelectorAll('[data-slide-panel]').forEach((panel) => {
            delete panel.dataset.wideScrollerCentered;
          });
          centerWideStageScroller(section);
          syncWideScrollProgress(section);
        }, 150);
      });
    };

    const initSection = (section) => {
      if (initializedSections.has(section)) {
        return;
      }

      if (section.dataset.accessoriesInitialized === 'true') {
        initializedSections.add(section);
        return;
      }

      initializedSections.add(section);
      section.dataset.accessoriesInitialized = 'true';

      const slideKeys = getSlideKeys(section);
      const activeTrigger = section.querySelector('[data-slide-trigger].is-active');
      const activePanel = section.querySelector('[data-slide-panel].is-active');
      const firstSlideKey = activeTrigger?.dataset.slideTrigger || activePanel?.dataset.slidePanel || section.dataset.defaultSlide || slideKeys[0];

      if (firstSlideKey) {
        activateSlide(section, firstSlideKey, { shouldScrollTab: false, resetInteractions: false });
      }

      section.querySelectorAll('[data-slide-trigger]').forEach((trigger) => {
        const slideKey = trigger.dataset.slideTrigger;

        trigger.addEventListener('click', () => activateSlide(section, slideKey));
      });

      initTabsNavigation(section);
      initControls(section);
      initDialogs(section);
      initVariantPickers(section);
      initChooseModelLink(section);
      initWideScrollers(section);
      syncInteractionDisplay(section);

      // 横竖屏/断点跨越时按当前断点重新同步双端视频的播放状态
      mobileMediaQuery.addEventListener('change', () => syncInteractionDisplay(section));
    };

    const initAll = (root = document) => {
      if (root instanceof Element && root.matches('[data-accessories-height-range]')) {
        initSection(root);
      }

      root.querySelectorAll('[data-accessories-height-range]').forEach(initSection);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('variant:add', () => {
      document.querySelectorAll('dialog.accessories-height-range__dialog[open]').forEach((dialog) => dialog.close());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-height-range"] && !Shopify.designMode) return;
  try {
    
  // accessories-height-range: custom variant picker + dialog logic
  (() => {
    const initializedSections = new WeakSet();

    const getSlideTriggers = (section) => Array.from(section.querySelectorAll('[data-slide-trigger]'));

    const syncTabsNavState = (section) => {
      const triggers = getSlideTriggers(section);
      const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
      const prevButton = section.querySelector('[data-tabs-prev]');
      const nextButton = section.querySelector('[data-tabs-next]');

      if (prevButton) {
        prevButton.disabled = activeIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = activeIndex === -1 || activeIndex >= triggers.length - 1;
      }
    };

    const scrollActiveTabIntoView = (section) => {
      const activeTrigger = section.querySelector('[data-slide-trigger].is-active');

      if (activeTrigger && typeof activeTrigger.scrollIntoView === 'function') {
        activeTrigger.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    };

    const activateSlide = (section, slideKey, options = {}) => {
      const { shouldScrollTab = true } = options;
      const panels = Array.from(section.querySelectorAll('[data-slide-panel]'));
      const triggers = getSlideTriggers(section);

      panels.forEach((panel) => {
        const isActive = panel.dataset.slidePanel === slideKey;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.slideTrigger === slideKey;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (shouldScrollTab) {
        scrollActiveTabIntoView(section);
      }

      syncTabsNavState(section);
    };

    const getSlideKeys = (section) => getSlideTriggers(section).map((trigger) => trigger.dataset.slideTrigger);

    const syncControlState = (section, type, nextState) => {
      section.dataset[`${type}On`] = String(nextState);
      section.querySelectorAll(`[data-toggle-control="${type}"]`).forEach((button) => {
        button.setAttribute('aria-pressed', nextState ? 'true' : 'false');
      });
    };

    const initControls = (section) => {
      section.querySelectorAll('[data-toggle-control]').forEach((button) => {
        button.addEventListener('click', () => {
          const type = button.dataset.toggleControl;
          const nextState = button.getAttribute('aria-pressed') !== 'true';
          syncControlState(section, type, nextState);
        });
      });
    };

    const closeVariantPicker = (picker) => {
      if (!picker) {
        return;
      }

      picker.classList.remove('is-open');

      const list = picker.querySelector('[data-variant-list]');
      const trigger = picker.querySelector('[data-variant-trigger]');

      if (list) {
        list.hidden = true;
      }

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    };

    const closeAllVariantPickers = (root = document) => {
      root.querySelectorAll('[data-variant-picker].is-open').forEach(closeVariantPicker);
    };

    const initDialogs = (section) => {
      section.querySelectorAll('[data-dialog-target]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = section.querySelector(`#${button.dataset.dialogTarget}`);

          if (dialog && typeof dialog.showModal === 'function') {
            dialog.showModal();
          }
        });
      });

      section.querySelectorAll('dialog.accessories-height-range__dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            dialog.close();
          }
        });

        dialog.addEventListener('close', () => {
          closeAllVariantPickers(dialog);
        });
      });
    };

    const initVariantPickers = (section) => {
      section.querySelectorAll('[data-variant-picker]').forEach((picker) => {
        const trigger = picker.querySelector('[data-variant-trigger]');
        const list = picker.querySelector('[data-variant-list]');
        const options = Array.from(list.querySelectorAll('[role="option"]'));
        const input = picker.querySelector('input[name="id"]');
        const valueEl = picker.querySelector('[data-selected-value]');
        const form = picker.closest('form');
        const priceEl = form?.querySelector('.accessories-height-range__dialog-price');
        const submitBtn = form?.querySelector('.accessories-height-range__dialog-submit');
        const card = picker.closest('.accessories-height-range__dialog-card');
        const imageEl = card?.querySelector('.accessories-height-range__dialog-image');

        const setOpen = (isOpen) => {
          picker.classList.toggle('is-open', isOpen);
          list.hidden = !isOpen;
          trigger.setAttribute('aria-expanded', String(isOpen));

          if (isOpen) {
            const selected = list.querySelector('[aria-selected="true"]') || options[0];
            if (selected) {
              selected.focus();
            }
          } else {
            trigger.focus();
          }
        };

        const updateSelection = (option) => {
          options.forEach((opt) => opt.setAttribute('aria-selected', 'false'));
          option.setAttribute('aria-selected', 'true');
          valueEl.textContent = option.textContent.trim();
          input.value = option.dataset.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));

          if (priceEl) {
            priceEl.textContent = option.dataset.price || priceEl.textContent;
          }

          if (imageEl && option.dataset.image) {
            imageEl.src = option.dataset.image;

            if (option.dataset.imageSrcset) {
              imageEl.srcset = option.dataset.imageSrcset;
            } else {
              imageEl.removeAttribute('srcset');
            }

            if (option.dataset.imageAlt) {
              imageEl.alt = option.dataset.imageAlt;
            }
          }

          if (submitBtn) {
            const available = option.dataset.available === 'true';
            submitBtn.disabled = !available;
            submitBtn.classList.toggle('is-sold-out', !available);
            const addLabel = submitBtn.dataset.addLabel || 'Add to Cart';
            const soldOutLabel = submitBtn.dataset.soldOutLabel || 'Sold out';
            submitBtn.textContent = available ? addLabel : soldOutLabel;
          }
        };

        trigger.addEventListener('click', (event) => {
          event.stopPropagation();

          const willOpen = !picker.classList.contains('is-open');

          section.querySelectorAll('[data-variant-picker].is-open').forEach((other) => {
            if (other !== picker) {
              closeVariantPicker(other);
            }
          });

          setOpen(willOpen);
        });

        list.addEventListener('click', (event) => {
          const option = event.target.closest('[role="option"]');
          if (!option) {
            return;
          }

          updateSelection(option);
          setOpen(false);
        });

        list.addEventListener('keydown', (event) => {
          const current = list.querySelector('[role="option"]:focus') || list.querySelector('[aria-selected="true"]');
          let next = null;

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            next = current?.nextElementSibling || options[0];
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            next = current?.previousElementSibling || options[options.length - 1];
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (current) {
              updateSelection(current);
              setOpen(false);
            }
          } else if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false);
          }

          if (next && next.matches('[role="option"]')) {
            next.focus();
          }
        });
      });
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-variant-picker].is-open')) {
        closeAllVariantPickers();
      }
    });

    const initChooseModelLink = (section) => {
      section.querySelectorAll('[data-scroll-top]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const hash = link.getAttribute('href');
          const target = hash ? document.querySelector(hash) : null;

          if (!target) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });
    };

    const initTabsNavigation = (section) => {
      const triggers = getSlideTriggers(section);
      const tabsScroller = section.querySelector('[data-tabs-scroller]');
      const prevButton = section.querySelector('[data-tabs-prev]');
      const nextButton = section.querySelector('[data-tabs-next]');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
          const previousTrigger = activeIndex > 0 ? triggers[activeIndex - 1] : null;

          if (previousTrigger) {
            activateSlide(section, previousTrigger.dataset.slideTrigger);
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          const activeIndex = triggers.findIndex((trigger) => trigger.classList.contains('is-active'));
          const nextTrigger = activeIndex > -1 && activeIndex < triggers.length - 1 ? triggers[activeIndex + 1] : null;

          if (nextTrigger) {
            activateSlide(section, nextTrigger.dataset.slideTrigger);
          }
        });
      }

      if (tabsScroller) {
        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let dragged = false;
        let suppressClick = false;

        tabsScroller.addEventListener('pointerdown', (event) => {
          if (event.pointerType == 'mouse' && event.button !== 0) {
            return;
          }

          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = tabsScroller.scrollLeft;
          dragged = false;
          suppressClick = false;
        });

        tabsScroller.addEventListener('pointermove', (event) => {
          if (pointerId !== event.pointerId) {
            return;
          }

          const deltaX = event.clientX - startX;

          if (Math.abs(deltaX) > 8) {
            if (!dragged) {
              if (typeof tabsScroller.setPointerCapture === 'function') {
                tabsScroller.setPointerCapture(pointerId);
              }

              suppressClick = true;
            }

            dragged = true;
          }

          if (dragged) {
            tabsScroller.scrollLeft = startScrollLeft - deltaX;
          }
        });

        const endDrag = (event) => {
          if (pointerId !== event.pointerId) {
            return;
          }

          if (typeof tabsScroller.hasPointerCapture === 'function' && tabsScroller.hasPointerCapture(pointerId)) {
            tabsScroller.releasePointerCapture(pointerId);
          }

          suppressClick = dragged;
          pointerId = null;
          dragged = false;
        };

        tabsScroller.addEventListener('pointerup', endDrag);
        tabsScroller.addEventListener('pointercancel', endDrag);

        tabsScroller.addEventListener('click', (event) => {
          if (suppressClick) {
            event.preventDefault();
            event.stopPropagation();
            suppressClick = false;
          }
        }, true);
      }

      syncTabsNavState(section);
    };

    const initSection = (section) => {
      if (initializedSections.has(section)) {
        return;
      }

      if (section.dataset.accessoriesInitialized === 'true') {
        initializedSections.add(section);
        return;
      }

      initializedSections.add(section);
      section.dataset.accessoriesInitialized = 'true';

      const slideKeys = getSlideKeys(section);
      const activeTrigger = section.querySelector('[data-slide-trigger].is-active');
      const activePanel = section.querySelector('[data-slide-panel].is-active');
      const firstSlideKey = activeTrigger?.dataset.slideTrigger || activePanel?.dataset.slidePanel || section.dataset.defaultSlide || slideKeys[0];

      if (firstSlideKey) {
        activateSlide(section, firstSlideKey, { shouldScrollTab: false });
      }

      section.querySelectorAll('[data-slide-trigger]').forEach((trigger) => {
        const slideKey = trigger.dataset.slideTrigger;

        trigger.addEventListener('click', () => activateSlide(section, slideKey));
      });

      initTabsNavigation(section);
      initControls(section);
      initDialogs(section);
      initVariantPickers(section);
      initChooseModelLink(section);
    };

    const initAll = (root = document) => {
      if (root instanceof Element && root.matches('[data-accessories-height-range]')) {
        initSection(root);
      }

      root.querySelectorAll('[data-accessories-height-range]').forEach(initSection);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('variant:add', () => {
      document.querySelectorAll('dialog.accessories-height-range__dialog[open]').forEach((dialog) => dialog.close());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-page-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-compare-page-section]';

    function parseJsonSafely(value, fallback) {
      if (!value) {
        return fallback;
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    }

    function normalizeSpecTemplate(template) {
      const rawGroups = Array.isArray(template?.groups) ? template.groups : [];

      return {
        groups: rawGroups
          .map((group) => {
            const title = typeof group?.title === 'string' ? group.title.trim() : '';
            const items = Array.isArray(group?.items)
              ? group.items
                  .map((item) => {
                    const label = typeof item?.label === 'string' ? item.label.trim() : '';
                    const path = typeof item?.path === 'string' ? item.path.trim() : '';

                    if (!label || !path) {
                      return null;
                    }

                    return {
                      label,
                      path,
                      important: Boolean(item?.important),
                    };
                  })
                  .filter(Boolean)
              : [];

            if (!title || !items.length) {
              return null;
            }

            return {
              title,
              items,
            };
          })
          .filter(Boolean),
      };
    }

    function getValueByPath(source, path) {
      if (!source || !path) {
        return null;
      }

      return path.split('.').reduce((current, key) => {
        if (current == null || typeof current !== 'object') {
          return null;
        }

        return Object.prototype.hasOwnProperty.call(current, key) ? current[key] : null;
      }, source);
    }

    function formatSpecValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }

      if (Array.isArray(value)) {
        return value.length ? value.join(', ') : '-';
      }

      if (typeof value === 'object') {
        const serialized = JSON.stringify(value);
        return serialized && serialized !== '{}' ? serialized : '-';
      }

      return String(value);
    }

    function normalizeSpecValueEntry(value) {
      if (typeof value === 'string') {
        const trimmedValue = value.trim();

        if (trimmedValue.startsWith('{') && trimmedValue.endsWith('}')) {
          const parsedValue = parseJsonSafely(trimmedValue, null);

          if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
            value = parsedValue;
          }
        }
      }

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const hasValueKey = Object.prototype.hasOwnProperty.call(value, 'value');
        const hasImportantKey = Object.prototype.hasOwnProperty.call(value, 'important');

        if (hasValueKey || hasImportantKey) {
          return {
            value: hasValueKey ? value.value : null,
            important: Boolean(value.important),
          };
        }
      }

      return {
        value,
        important: false,
      };
    }

    function renderSpecMatrix(matrix, specTemplate, columnsData) {
      if (!matrix) {
        return;
      }

      matrix.replaceChildren();

      specTemplate.groups.forEach((group) => {
        const specGroup = document.createElement('section');
        specGroup.className = 'compare-page-section__spec-group';

        const header = document.createElement('div');
        header.className = 'compare-page-section__spec-group-header';

        const title = document.createElement('h4');
        title.className = 'compare-page-section__spec-group-title';
        title.textContent = group.title;
        header.appendChild(title);
        specGroup.appendChild(header);

        group.items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'compare-page-section__spec-row';

          columnsData.forEach((columnData) => {
            const cell = document.createElement('article');
            cell.className = 'compare-page-section__spec-cell';

            const label = document.createElement('p');
            label.className = 'compare-page-section__spec-label';
            label.textContent = item.label;

            const specEntry = normalizeSpecValueEntry(getValueByPath(columnData?.product?.compare_specs, item.path));
            const value = document.createElement('p');
            value.className = `compare-page-section__spec-value${item.important || specEntry.important ? ' compare-page-section__spec-value--important' : ''}`;
            value.textContent = formatSpecValue(specEntry.value);

            cell.append(label, value);
            row.appendChild(cell);
          });

          specGroup.appendChild(row);
        });

        matrix.appendChild(specGroup);
      });
    }

    function getCompareSwatchState(swatch) {
      if (!swatch) {
        return null;
      }

      return {
        image: swatch.dataset.images || '',
        url: swatch.dataset.url || '',
        alt: swatch.dataset.title || '',
      };
    }

    function updateCompareCardState(card, nextState) {
      if (!card || !nextState) {
        return;
      }

      const image = nextState.image || card.dataset.defaultImage || '';
      const alt = nextState.alt || card.dataset.defaultImageAlt || '';
      const url = nextState.url || card.dataset.defaultUrl || '#';
      const mediaImage = card.querySelector('[data-role="product-image"], .compare-page-section__product-image, .compare-section__product-image');

      if (mediaImage && image) {
        mediaImage.src = image;
        mediaImage.alt = alt;
        mediaImage.removeAttribute('srcset');
      }

      card.querySelectorAll('[data-compare-product-link]').forEach((link) => {
        link.setAttribute('href', url);
      });
    }

    function applySelectedCompareSwatch(card) {
      if (!card) {
        return;
      }

      const selectedSwatch = card.querySelector('[data-compare-swatch-group] input:checked + .color-swatch');

      updateCompareCardState(card, selectedSwatch ? getCompareSwatchState(selectedSwatch) : null);
    }

    function bindCompareSwatchCard(card) {
      if (!card || card.dataset.compareSwatchReady === 'true') {
        applySelectedCompareSwatch(card);
        return;
      }

      const previewSwatch = (target) => {
        const swatch = target?.closest?.('[data-compare-swatch-group] .color-swatch');

        if (!swatch || !card.contains(swatch)) {
          return;
        }

        updateCompareCardState(card, getCompareSwatchState(swatch));
      };

      card.dataset.compareSwatchReady = 'true';

      card.addEventListener('mouseover', (event) => {
        previewSwatch(event.target);
      });

      card.addEventListener('focusin', (event) => {
        previewSwatch(event.target);
      });

      card.addEventListener('mouseleave', () => {
        applySelectedCompareSwatch(card);
      });

      card.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!card.contains(document.activeElement)) {
            applySelectedCompareSwatch(card);
          }
        });
      });

      card.addEventListener('change', (event) => {
        if (event.target.matches('[data-compare-swatch-group] input[type="radio"]')) {
          applySelectedCompareSwatch(card);
        }
      });

      applySelectedCompareSwatch(card);
    }

    function updateColumnProduct(column, stickyItem, product) {
      if (!column || !stickyItem || !product) {
        return;
      }

      const mediaLink = column.querySelector('[data-role="product-image-link"]');
      const mediaFrame = column.querySelector('[data-role="product-media-frame"]');
      const titleLink = column.querySelector('[data-role="product-title-link"]');
      const title = column.querySelector('[data-role="product-title"]');
      const description = column.querySelector('[data-role="product-description"]');
      const card = column.querySelector('.compare-page-section__product-card');
      const upgradeLabel = column.querySelector('[data-role="upgrade-label"]');
      const productSalePrice = column.querySelector('.compare-page-section__product-sale-price');
      const productComparePrice = column.querySelector('.compare-page-section__product-compare-price');
      const productButton = column.querySelector('.compare-page-section__button');
      const productSwatches = column.querySelector('[data-role="product-swatches"]');
      const stickySalePrice = stickyItem.querySelector('.compare-page-section__sticky-sale-price');
      const stickyComparePrice = stickyItem.querySelector('.compare-page-section__sticky-compare-price');
      const stickyButton = stickyItem.querySelector('.compare-page-section__sticky-button');
      const placeholderTemplate = column
        .closest('[data-compare-page-section]')
        ?.querySelector('[data-compare-page-placeholder]');
      const descriptionOverride = column.querySelector('.compare-page-section__product-card')?.dataset.descriptionOverride || '';

      if (mediaLink) {
        mediaLink.href = product.url || '#';
      }

      if (mediaFrame) {
        if (product.image) {
          const mediaImage = document.createElement('img');
          mediaImage.className = 'compare-page-section__product-image';
          mediaImage.setAttribute('data-role', 'product-image');
          mediaImage.loading = 'lazy';
          mediaImage.src = product.image;
          mediaImage.alt = product.image_alt || product.title || '';

          mediaFrame.replaceChildren(mediaImage);
        } else if (placeholderTemplate) {
          mediaFrame.innerHTML = placeholderTemplate.innerHTML;
        } else {
          mediaFrame.replaceChildren();
        }
      }

      if (titleLink) {
        titleLink.href = product.url || '#';
      }

      if (title) {
        title.textContent = product.title || '';
      }

      if (description) {
        const nextDescription = descriptionOverride || product.description || '';

        description.textContent = nextDescription;
        description.classList.toggle('is-hidden', !nextDescription);
      }

      if (card) {
        card.dataset.defaultImage = product.image || '';
        card.dataset.defaultImageAlt = product.image_alt || product.title || '';
        card.dataset.defaultUrl = product.url || '#';
        card.classList.toggle('compare-page-section__product-card--upgrade', Boolean(product.show_upgrade_label));
        bindCompareSwatchCard(card);
      }

      if (upgradeLabel) {
        upgradeLabel.classList.toggle('is-hidden', !product.show_upgrade_label);
      }

      if (productSwatches) {
        productSwatches.innerHTML = product.swatches_html || '';
        productSwatches.classList.toggle('is-hidden', !product.swatches_html);
      }

      if (productSalePrice) {
        productSalePrice.textContent = product.price || '-';
      }

      if (productComparePrice) {
        productComparePrice.textContent = product.compare_at_price || '';
        productComparePrice.classList.toggle('is-hidden', !product.compare_at_price);
      }

      if (productButton) {
        productButton.href = product.url || '#';
      }

      if (stickySalePrice) {
        stickySalePrice.textContent = product.price || '-';
      }

      if (stickyComparePrice) {
        stickyComparePrice.textContent = product.compare_at_price || '';
        stickyComparePrice.classList.toggle('is-hidden', !product.compare_at_price);
      }

      if (stickyButton) {
        stickyButton.href = product.url || '#';
      }

      if (card) {
        applySelectedCompareSwatch(card);
      }
    }

    function initComparePageSection(section) {
      if (!section || section.dataset.comparePageReady === 'true') {
        return;
      }

      const stickySummary = section.querySelector('[data-compare-page-sticky-summary]');
      const mediaItems = Array.from(section.querySelectorAll('[data-compare-media]'));
      const toggleButton = section.querySelector('[data-compare-page-toggle]');
      const grid = section.querySelector('[data-compare-page-grid]');
      const stickyTrack = section.querySelector('[data-compare-page-sticky-track]');
      const specTemplateNode = section.querySelector('[data-compare-page-spec-template]');
      const specMatrix = section.querySelector('[data-compare-page-spec-matrix]');
      const columns = Array.from(section.querySelectorAll('[data-compare-page-column]'));
      const specTemplate = normalizeSpecTemplate(parseJsonSafely(specTemplateNode?.textContent?.trim(), { groups: [] }));

      if (!stickySummary || !grid || !stickyTrack || !specMatrix || !columns.length) {
        return;
      }

      section.dataset.comparePageReady = 'true';
      section.querySelectorAll('[data-compare-product-card]').forEach(bindCompareSwatchCard);

      let animationFrame = null;
      let syncingScroller = null;
      const columnsData = columns.map(() => ({ product: null }));

      columns.forEach((column, columnIndex) => {
        const columnId = column.dataset.columnId;
        const stickyItem = stickyTrack.querySelector(`[data-compare-page-sticky-item][data-column-id="${columnId}"]`);
        const productJson = column.querySelector('[data-compare-page-products-json]');
        const selects = Array.from(section.querySelectorAll(`[data-compare-page-select][data-column-id="${columnId}"]`));

        if (!stickyItem || !productJson || !selects.length) {
          return;
        }

        let products = [];

        try {
          products = JSON.parse(productJson.textContent.trim() || '[]');
        } catch (error) {
          products = [];
        }

        products = products.map((product) => ({
          ...product,
          compare_specs:
            typeof product?.compare_specs === 'string'
              ? parseJsonSafely(product.compare_specs, null)
              : product?.compare_specs || null,
        }));

        if (!products.length) {
          columnsData[columnIndex].product = null;
          return;
        }

        const productMap = new Map(products.map((product) => [String(product.id), product]));

        const renderSelectedProduct = (selectedId) => {
          const fallbackProduct = products[0];
          const nextProduct = productMap.get(String(selectedId)) || fallbackProduct;

          selects.forEach((select) => {
            if (select.value !== String(nextProduct.id)) {
              select.value = String(nextProduct.id);
            }
          });

          columnsData[columnIndex].product = nextProduct;
          updateColumnProduct(column, stickyItem, nextProduct);
          renderSpecMatrix(specMatrix, specTemplate, columnsData);
        };

        selects.forEach((select) => {
          select.addEventListener('change', (event) => {
            renderSelectedProduct(event.currentTarget.value);
          });
        });

        renderSelectedProduct(selects[0].value || String(products[0].id));
      });

      renderSpecMatrix(specMatrix, specTemplate, columnsData);

      const syncStickyTop = () => {
        const rootStyles = window.getComputedStyle(document.documentElement);
        const stickyAreaHeight = parseFloat(rootStyles.getPropertyValue('--sticky-area-height')) || 0;
        const stickyHeader = document.querySelector('.shopify-section--header');

        let stickyTop = stickyAreaHeight;

        if (stickyHeader) {
          const headerRect = stickyHeader.getBoundingClientRect();

          if (headerRect.bottom > 0) {
            stickyTop = Math.max(stickyTop, Math.floor(headerRect.bottom));
          }
        }

        stickySummary.style.setProperty('--compare-page-sticky-top', `${Math.max(0, stickyTop)}px`);

        return stickyTop;
      };

      const updateStickyState = () => {
        animationFrame = null;

        const stickyTop = syncStickyTop();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        let hasScrolledPastMedia = false;
        let allMediaHidden = true;

        mediaItems.forEach((mediaItem) => {
          const rect = mediaItem.getBoundingClientRect();

          if (rect.top < stickyTop) {
            hasScrolledPastMedia = true;
          }

          if (rect.bottom > stickyTop && rect.top < viewportHeight) {
            allMediaHidden = false;
          }
        });

        const shouldShow = hasScrolledPastMedia && allMediaHidden;

        stickySummary.classList.toggle('is-visible', shouldShow);
        stickySummary.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      const requestUpdate = () => {
        if (animationFrame !== null) {
          return;
        }

        animationFrame = window.requestAnimationFrame(updateStickyState);
      };

      const syncScrollPosition = (source, target) => {
        if (!source || !target) {
          return;
        }

        if (syncingScroller === source) {
          return;
        }

        syncingScroller = source;
        target.scrollLeft = source.scrollLeft;

        window.requestAnimationFrame(() => {
          syncingScroller = null;
        });
      };

      const handleGridScroll = () => syncScrollPosition(grid, stickyTrack);
      const handleStickyTrackScroll = () => syncScrollPosition(stickyTrack, grid);

      const handleToggleClick = () => {
        const isCollapsed = section.classList.toggle('is-collapsed');

        if (toggleButton) {
          toggleButton.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        }
      };

      const handleSectionUnload = (event) => {
        if (event.detail && event.detail.sectionId !== '{{ section.id }}') {
          return;
        }

        if (toggleButton) {
          toggleButton.removeEventListener('click', handleToggleClick);
        }

        grid.removeEventListener('scroll', handleGridScroll);
        stickyTrack.removeEventListener('scroll', handleStickyTrackScroll);
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
      };

      grid.addEventListener('scroll', handleGridScroll, { passive: true });
      stickyTrack.addEventListener('scroll', handleStickyTrackScroll, { passive: true });
      stickyTrack.scrollLeft = grid.scrollLeft;

      if (toggleButton) {
        toggleButton.addEventListener('click', handleToggleClick);
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      document.addEventListener('shopify:section:unload', handleSectionUnload);

      requestUpdate();
    }

    function boot(targetSection) {
      if (targetSection && targetSection.nodeType === 1) {
        initComparePageSection(targetSection);
        return;
      }

      document.querySelectorAll(selector).forEach(initComparePageSection);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.detail || event.detail.sectionId !== '{{ section.id }}') {
        return;
      }

      boot(document.querySelector('#shopify-section-{{ section.id }} [data-compare-page-section]'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-compare-section]';
    const defaultSpecTemplate = {
      groups: [
        {
          key: 'motor',
          title: 'Motor',
          items: [
            { label: 'Range', path: 'motor.range', important: false },
            { label: 'Top safe speed', path: 'motor.top_safe_speed', important: false },
            { label: 'Shifting speeds', path: 'motor.shifting_speeds', important: false },
            { label: 'Pedal assist mode', path: 'motor.pedal_assist_mode', important: false },
            { label: 'Reverse function', path: 'motor.reverse_function', important: false },
            { label: 'Fast charging support', path: 'motor.fast_charging_support', important: false },
            { label: 'Max load capacity', path: 'motor.max_load_capacity', important: false },
            { label: 'Net weight', path: 'motor.net_weight', important: false },
          ],
        },
        {
          key: 'electric_system',
          title: 'Electric system',
          items: [
            { label: 'Motor', path: 'electric_system.motor', important: false },
            { label: 'Battery', path: 'electric_system.battery', important: false },
            { label: 'Display', path: 'electric_system.display', important: false },
            { label: 'Controller', path: 'electric_system.controller', important: false },
            { label: 'Pedal sensor', path: 'electric_system.pedal_sensor', important: false },
            { label: 'Charger', path: 'electric_system.charger', important: false },
            { label: 'Throttle', path: 'electric_system.throttle', important: false },
            { label: 'Headlights', path: 'electric_system.headlights', important: false },
            { label: 'Taillights', path: 'electric_system.taillights', important: false },
            { label: 'Position lights (fenders)', path: 'electric_system.positionlights_fenders', important: false },
          ],
        },
        {
          key: 'brakeset',
          title: 'Brakeset',
          items: [
            { label: 'Brake caliper', path: 'brakeset.brake_caliper', important: false },
            { label: 'Brake lever', path: 'brakeset.brake_lever', important: false },
            { label: 'Rotors', path: 'brakeset.rotors', important: false },
          ],
        },
        {
          key: 'drivetrain',
          title: 'Drivetrain',
          items: [
            { label: 'Shifter', path: 'drivetrain.shifter', important: false },
            { label: 'Rear derailleur', path: 'drivetrain.rear_derailleur', important: false },
            { label: 'Freewheel', path: 'drivetrain.freewheel', important: false },
            { label: 'Crank wheel', path: 'drivetrain.crank_wheel', important: false },
            { label: 'Chain', path: 'drivetrain.chain', important: false },
          ],
        },
        {
          key: 'wheelset',
          title: 'Wheelset',
          items: [
            { label: 'Tire', path: 'wheelset.tire', important: false },
            { label: 'Rim', path: 'wheelset.rim', important: false },
            { label: 'Hub', path: 'wheelset.hub', important: false },
            { label: 'Spokes', path: 'wheelset.spokes', important: false },
          ],
        },
        {
          key: 'components',
          title: 'Components',
          items: [
            { label: 'Differential mechanism', path: 'components.differential_mechanism', important: false },
            { label: 'Frame', path: 'components.frame', important: false },
            { label: 'Fork', path: 'components.fork', important: false },
            { label: 'Handle bar', path: 'components.handlebar', important: false },
            { label: 'Stem', path: 'components.stem', important: false },
            { label: 'Seat post', path: 'components.seat_post', important: false },
            { label: 'Grip', path: 'components.grip', important: false },
            { label: 'Saddle', path: 'components.saddle', important: false },
            { label: 'Basket', path: 'components.basket', important: false },
            { label: 'Fenders', path: 'components.fenders', important: false },
            { label: 'Assembly', path: 'components.assembly', important: false },
          ],
        },
      ],
    };

    function parseJsonSafely(value, fallback) {
      if (!value) {
        return fallback;
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    }

    function normalizeSpecTemplate(template) {
      const rawGroups = Array.isArray(template?.groups) ? template.groups : [];

      return {
        groups: rawGroups
          .map((group) => {
            const key = typeof group?.key === 'string' ? group.key.trim() : '';
            const title = typeof group?.title === 'string' ? group.title.trim() : '';
            const items = Array.isArray(group?.items)
              ? group.items
                  .map((item) => {
                    const label = typeof item?.label === 'string' ? item.label.trim() : '';
                    const path = typeof item?.path === 'string' ? item.path.trim() : '';

                    if (!label || !path) {
                      return null;
                    }

                    return {
                      label,
                      path,
                      important: Boolean(item?.important),
                    };
                  })
                  .filter(Boolean)
              : [];

            if (!title || !items.length) {
              return null;
            }

            return {
              key,
              title,
              items,
            };
          })
          .filter(Boolean),
      };
    }

    function normalizeGroupKey(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    }

    function getValueByPath(source, path) {
      if (!source || !path) {
        return null;
      }

      return path.split('.').reduce((current, key) => {
        if (current == null || typeof current !== 'object') {
          return null;
        }

        return Object.prototype.hasOwnProperty.call(current, key) ? current[key] : null;
      }, source);
    }

    function formatSpecValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }

      if (Array.isArray(value)) {
        return value.length ? value.join(', ') : '-';
      }

      if (typeof value === 'object') {
        const serialized = JSON.stringify(value);
        return serialized && serialized !== '{}' ? serialized : '-';
      }

      return String(value);
    }

    function normalizeSpecValueEntry(value) {
      if (typeof value === 'string') {
        const trimmedValue = value.trim();

        if (trimmedValue.startsWith('{') && trimmedValue.endsWith('}')) {
          const parsedValue = parseJsonSafely(trimmedValue, null);

          if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
            value = parsedValue;
          }
        }
      }

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const hasValueKey = Object.prototype.hasOwnProperty.call(value, 'value');
        const hasImportantKey = Object.prototype.hasOwnProperty.call(value, 'important');

        if (hasValueKey || hasImportantKey) {
          return {
            value: hasValueKey ? value.value : null,
            important: Boolean(value.important),
          };
        }
      }

      return {
        value,
        important: false,
      };
    }

    function getSpecIconMarkup(section, group) {
      const groupKey = normalizeGroupKey(group?.key || group?.title);
      const iconTemplate = section?.querySelector(`[data-compare-spec-icon="${groupKey}"]`);

      return iconTemplate ? iconTemplate.innerHTML.trim() : '';
    }

    function normalizeProductData(product) {
      if (!product) {
        return null;
      }

      return {
        ...product,
        compare_specs:
          typeof product?.compare_specs === 'string'
            ? parseJsonSafely(product.compare_specs, null)
            : product?.compare_specs || null,
      };
    }

    function getCompareSwatchState(swatch) {
      if (!swatch) {
        return null;
      }

      return {
        image: swatch.dataset.images || '',
        url: swatch.dataset.url || '',
        alt: swatch.dataset.title || '',
      };
    }

    function updateCompareCardState(card, nextState) {
      if (!card || !nextState) {
        return;
      }

      const image = nextState.image || card.dataset.defaultImage || '';
      const alt = nextState.alt || card.dataset.defaultImageAlt || '';
      const url = nextState.url || card.dataset.defaultUrl || '#';
      const mediaImage = card.querySelector('[data-role="product-image"], .compare-section__product-image, .compare-page-section__product-image');

      if (mediaImage && image) {
        mediaImage.src = image;
        mediaImage.alt = alt;
        mediaImage.removeAttribute('srcset');
      }

      card.querySelectorAll('[data-compare-product-link]').forEach((link) => {
        link.setAttribute('href', url);
      });
    }

    function applySelectedCompareSwatch(card) {
      if (!card) {
        return;
      }

      const selectedSwatch = card.querySelector('[data-compare-swatch-group] input:checked + .color-swatch');

      updateCompareCardState(card, selectedSwatch ? getCompareSwatchState(selectedSwatch) : null);
    }

    function bindCompareSwatchCard(card) {
      if (!card || card.dataset.compareSwatchReady === 'true') {
        applySelectedCompareSwatch(card);
        return;
      }

      const previewSwatch = (target) => {
        const swatch = target?.closest?.('[data-compare-swatch-group] .color-swatch');

        if (!swatch || !card.contains(swatch)) {
          return;
        }

        updateCompareCardState(card, getCompareSwatchState(swatch));
      };

      card.dataset.compareSwatchReady = 'true';

      card.addEventListener('mouseover', (event) => {
        previewSwatch(event.target);
      });

      card.addEventListener('focusin', (event) => {
        previewSwatch(event.target);
      });

      card.addEventListener('mouseleave', () => {
        applySelectedCompareSwatch(card);
      });

      card.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!card.contains(document.activeElement)) {
            applySelectedCompareSwatch(card);
          }
        });
      });

      card.addEventListener('change', (event) => {
        if (event.target.matches('[data-compare-swatch-group] input[type="radio"]')) {
          applySelectedCompareSwatch(card);
        }
      });

      applySelectedCompareSwatch(card);
    }

    function renderSpecMatrix(section, matrix, specTemplate, columnsData) {
      if (!matrix) {
        return;
      }

      matrix.replaceChildren();

      const highlights = document.createElement('div');
      highlights.className = 'compare-section__spec-column-highlights';

      columnsData.forEach((column) => {
        const highlight = document.createElement('div');
        highlight.className = `compare-section__spec-column-highlight${column.floating ? ' is-floating' : ''}`;
        highlights.appendChild(highlight);
      });

      matrix.appendChild(highlights);

      specTemplate.groups.forEach((group) => {
        const specGroup = document.createElement('section');
        specGroup.className = 'compare-section__spec-group';

        const headerRow = document.createElement('div');
        headerRow.className = 'compare-section__spec-group-header';
        const iconMarkup = getSpecIconMarkup(section, group);
        const groupKey = normalizeGroupKey(group?.key || group?.title);

        columnsData.forEach((column, columnIndex) => {
          const heading = document.createElement('div');
          heading.className = 'compare-section__spec-group-heading';

          const title = document.createElement('h4');
          title.className = `compare-section__spec-group-title${columnIndex === 0 ? '' : ' compare-section__spec-group-title--hidden'}`;

          const titleText = document.createElement('span');
          titleText.className = 'compare-section__spec-group-title-text';
          titleText.textContent = group.title;
          title.appendChild(titleText);

          if (iconMarkup) {
            const icon = document.createElement('span');

            icon.className = `compare-section__spec-group-icon${groupKey === 'drivetrain' ? ' compare-section__spec-group-icon--drivetrain' : ''}`;
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML = iconMarkup;
            title.appendChild(icon);
          }

          heading.appendChild(title);
          headerRow.appendChild(heading);
        });

        specGroup.appendChild(headerRow);

        group.items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'compare-section__spec-row';

          columnsData.forEach((column) => {
            const cell = document.createElement('article');
            cell.className = `compare-section__spec-cell${column.floating ? ' compare-section__spec-cell--floating' : ''}`;

            const label = document.createElement('p');
            label.className = 'compare-section__spec-label';
            label.textContent = item.label;

            const specEntry = normalizeSpecValueEntry(getValueByPath(column.product?.compare_specs, item.path));
            const value = document.createElement('p');
            value.className = `compare-section__spec-value${item.important || specEntry.important ? ' compare-section__spec-value--important' : ''}`;
            value.textContent = formatSpecValue(specEntry.value);

            cell.append(label, value);
            row.appendChild(cell);
          });

          specGroup.appendChild(row);
        });

        matrix.appendChild(specGroup);
      });
    }

    function initCompareSection(section) {
      if (!section || section.dataset.compareSectionReady === 'true') {
        return;
      }

      const specTemplateNode = section.querySelector('[data-compare-spec-template]');
      const columns = Array.from(section.querySelectorAll('[data-compare-column]'));
      const stickySummary = section.querySelector('[data-compare-sticky-summary]');
      const mediaItems = Array.from(section.querySelectorAll('[data-compare-media]'));
      const toggleButton = section.querySelector('[data-compare-toggle]');
      const grid = section.querySelector('[data-compare-grid]');
      const stickyTrack = section.querySelector('[data-compare-sticky-track]');
      const specMatrix = section.querySelector('[data-compare-spec-matrix]');
      const specTemplate = normalizeSpecTemplate(parseJsonSafely(specTemplateNode?.textContent?.trim(), defaultSpecTemplate));

      if (!columns.length) {
        return;
      }

      section.dataset.compareSectionReady = 'true';

      section.querySelectorAll('[data-compare-product-card]').forEach(bindCompareSwatchCard);

      const columnsData = columns.map((column) => {
        const productJsonNode = column.querySelector('[data-compare-product-json]');
        const product = parseJsonSafely(productJsonNode?.textContent?.trim(), null);
        return {
          floating: column.dataset.compareColumnFloating === 'true',
          product: normalizeProductData(product),
        };
      });

      renderSpecMatrix(section, specMatrix, specTemplate, columnsData);

      if (!stickySummary || !mediaItems.length) {
        return;
      }

      let animationFrame = null;
      let syncingScroller = null;

      const syncStickyTop = () => {
        const rootStyles = window.getComputedStyle(document.documentElement);
        const stickyAreaHeight = parseFloat(rootStyles.getPropertyValue('--sticky-area-height')) || 0;
        const stickyHeader = document.querySelector('.shopify-section--header');

        let stickyTop = stickyAreaHeight;

        if (stickyHeader) {
          const headerRect = stickyHeader.getBoundingClientRect();

          if (headerRect.bottom > 0) {
            stickyTop = Math.max(stickyTop, Math.floor(headerRect.bottom));
          }
        }

        stickySummary.style.setProperty('--compare-section-sticky-top', `${Math.max(0, stickyTop)}px`);

        return stickyTop;
      };

      const updateStickyState = () => {
        animationFrame = null;

        const stickyTop = syncStickyTop();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        let hasScrolledPastMedia = false;
        let allMediaHidden = true;

        mediaItems.forEach((mediaItem) => {
          const rect = mediaItem.getBoundingClientRect();

          if (rect.top < stickyTop) {
            hasScrolledPastMedia = true;
          }

          if (rect.bottom > stickyTop && rect.top < viewportHeight) {
            allMediaHidden = false;
          }
        });

        const shouldShow = hasScrolledPastMedia && allMediaHidden;

        stickySummary.classList.toggle('is-visible', shouldShow);
        stickySummary.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      const requestUpdate = () => {
        if (animationFrame !== null) {
          return;
        }

        animationFrame = window.requestAnimationFrame(updateStickyState);
      };

      const syncScrollPosition = (source, target) => {
        if (!source || !target) {
          return;
        }

        if (syncingScroller === source) {
          return;
        }

        syncingScroller = source;
        target.scrollLeft = source.scrollLeft;

        window.requestAnimationFrame(() => {
          syncingScroller = null;
        });
      };

      const handleGridScroll = () => syncScrollPosition(grid, stickyTrack);
      const handleStickyTrackScroll = () => syncScrollPosition(stickyTrack, grid);

      const handleToggleClick = () => {
        const isCollapsed = section.classList.toggle('is-collapsed');

        if (toggleButton) {
          toggleButton.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        }
      };

      const handleSectionUnload = (event) => {
        if (event.detail && event.detail.sectionId !== '{{ section.id }}') {
          return;
        }

        if (toggleButton) {
          toggleButton.removeEventListener('click', handleToggleClick);
        }

        if (grid) {
          grid.removeEventListener('scroll', handleGridScroll);
        }

        if (stickyTrack) {
          stickyTrack.removeEventListener('scroll', handleStickyTrackScroll);
        }

        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
      };

      if (toggleButton) {
        toggleButton.addEventListener('click', handleToggleClick);
      }

      if (grid && stickyTrack) {
        grid.addEventListener('scroll', handleGridScroll, { passive: true });
        stickyTrack.addEventListener('scroll', handleStickyTrackScroll, { passive: true });
        stickyTrack.scrollLeft = grid.scrollLeft;
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      document.addEventListener('shopify:section:unload', handleSectionUnload);

      requestUpdate();
    }

    function boot(targetSection) {
      if (targetSection && targetSection.nodeType === 1) {
        initCompareSection(targetSection);
        return;
      }

      document.querySelectorAll(selector).forEach(initCompareSection);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.detail || event.detail.sectionId !== '{{ section.id }}') {
        return;
      }

      boot(document.querySelector('#shopify-section-{{ section.id }} [data-compare-section]'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-campaign"] && !Shopify.designMode) return;
  try {
    
  /* 视频卡翻页：Product Youtube Swiper 同款交互（原生 JS 实现，不依赖 Swiper 库） */
  (function () {
    function initHcVideosNav(root) {
      const grid = root.querySelector('[data-hc-videos-grid]');
      const scrollbar = root.querySelector('[data-hc-videos-scrollbar]');
      const drag = root.querySelector('[data-hc-videos-scrollbar-drag]');
      const prevBtn = root.querySelector('[data-hc-videos-prev]');
      const nextBtn = root.querySelector('[data-hc-videos-next]');
      if (!grid || !scrollbar || !drag) return;

      function updateScrollbar() {
        const maxScroll = grid.scrollWidth - grid.clientWidth;
        const progress = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
        const trackWidth = scrollbar.clientWidth;
        const dragWidth = Math.max(40, trackWidth * (grid.clientWidth / grid.scrollWidth));
        const x = progress * (trackWidth - dragWidth);
        drag.style.width = dragWidth + 'px';
        drag.style.transform = 'translateX(' + x + 'px)';
      }

      function scrollByCard(dir) {
        const card = grid.querySelector('.hc-video-card');
        if (!card) return;
        const gap = parseInt(getComputedStyle(grid).gap) || 24;
        const step = card.offsetWidth + gap;
        grid.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      grid.addEventListener('scroll', updateScrollbar, { passive: true });
      window.addEventListener('resize', updateScrollbar);
      updateScrollbar();

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));

      /* 拖拽滑动：Pointer Events 统一桌面鼠标与手机触摸 */
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragging = false;
      let dragMoved = false;

      grid.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return; /* 触摸走原生惯性滚动 */
        dragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = grid.scrollLeft;
        grid.classList.add('hc-videos__grid--dragging');
        /* 注意：不可在 pointerdown 就 setPointerCapture，否则 click 目标会被重定向到 grid，卡片点击失效 */
      });

      grid.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 6) {
          if (!dragMoved) {
            try { grid.setPointerCapture(e.pointerId); } catch (err) {}
          }
          dragMoved = true;
          grid.scrollLeft = dragStartScroll - dx;
        }
      });

      function endDrag() {
        dragging = false;
        grid.classList.remove('hc-videos__grid--dragging');
      }
      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointercancel', endDrag);
      document.addEventListener('pointerup', endDrag); /* 未捕获时在容器外松手兜底 */

      /* 进度条拖动 + 点击轨道跳转 */
      let sbDragging = false;

      function scrollFromClientX(clientX) {
        const rect = scrollbar.getBoundingClientRect();
        const trackWidth = rect.width;
        const dragWidth = drag.offsetWidth;
        const maxScroll = grid.scrollWidth - grid.clientWidth;
        if (maxScroll <= 0 || trackWidth - dragWidth <= 0) return;
        let ratio = (clientX - rect.left - dragWidth / 2) / (trackWidth - dragWidth);
        ratio = Math.min(1, Math.max(0, ratio));
        grid.scrollLeft = ratio * maxScroll;
      }

      drag.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        sbDragging = true;
        try { drag.setPointerCapture(e.pointerId); } catch (err) {}
      });

      drag.addEventListener('pointermove', (e) => {
        if (!sbDragging) return;
        scrollFromClientX(e.clientX);
      });

      function endSbDrag() { sbDragging = false; }
      drag.addEventListener('pointerup', endSbDrag);
      drag.addEventListener('pointercancel', endSbDrag);

      /* 点击轨道空白处快速跳转 */
      scrollbar.addEventListener('pointerdown', (e) => {
        if (e.target === drag) return;
        scrollFromClientX(e.clientX);
      });

      /* 拖拽后的 click 不触发视频播放（capture 阶段拦截，优先于 document 级播放监听） */
      grid.addEventListener('click', (e) => {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);

      /* 点击封面放大播放（Product Youtube Swiper 同款弹窗） */
      const popup = root.querySelector('[data-hc-video-popup]');
      const popupContent = root.querySelector('[data-hc-video-popup-content]');
      const popupClose = root.querySelector('[data-hc-video-popup-close]');

      /* section 根元素带 z-index: 0 形成 stacking context，弹窗需挂到 body 下才能压过 sticky header */
      if (popup && popup.parentNode !== document.body) {
        document.body.appendChild(popup);
      }

      function closeVideoPopup() {
        if (!popup) return;
        popup.classList.remove('hc-video-popup--open');
        if (popupContent) popupContent.innerHTML = '';
      }

      if (popup && popupContent) {
        grid.querySelectorAll('.hc-video-card__media').forEach((media) => {
          media.addEventListener('click', () => {
            const card = media.closest('.hc-video-card');
            const videoId = card ? card.getAttribute('data-video-id') : '';
            if (!videoId) return;
            popupContent.innerHTML = '<iframe class="hc-video-popup__iframe" frameborder="0" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" src="https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1"></iframe>';
            popup.classList.add('hc-video-popup--open');
          });
        });

        if (popupClose) {
          popupClose.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            closeVideoPopup();
          });
        }

        /* 点击遮罩空白处关闭 */
        popup.addEventListener('click', (e) => {
          if (!e.target.closest('.hc-video-popup__layout')) closeVideoPopup();
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') closeVideoPopup();
        });
      }
    }

    document.querySelectorAll('.hc-videos').forEach(initHcVideosNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-magic-bento"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-mc-magic-bento]';
    const DESKTOP_MEDIA_QUERY = '(min-width: 1000px) and (hover: hover) and (pointer: fine)';
    const initializedSections = new WeakSet();

    const desktopInteractive = () => window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

    const initCardInteractions = (section) => {
      const glowRadius = 200;

      section.querySelectorAll('[data-magic-card]').forEach((surface) => {
        if (surface.dataset.magicCardReady === 'true') {
          return;
        }

        surface.dataset.magicCardReady = 'true';
        surface.style.setProperty('--magic-glow-radius', `${glowRadius}px`);

        surface.addEventListener('pointerenter', () => {
          if (!desktopInteractive()) {
            return;
          }

          surface.classList.add('is-active');
          surface.style.setProperty('--magic-glow-intensity', '1');
        });

        surface.addEventListener('pointerleave', () => {
          surface.classList.remove('is-active');
          surface.style.setProperty('--magic-glow-intensity', '0');
        });

        surface.addEventListener('pointercancel', () => {
          surface.classList.remove('is-active');
          surface.style.setProperty('--magic-glow-intensity', '0');
        });
      });
    };

    const initMobileCarousel = (section) => {
      const grid = section.querySelector('.mc-magic-bento__grid');
      const dotsBox = section.querySelector('[data-bento-dots]');
      const prevButton = section.querySelector('[data-bento-prev]');
      const nextButton = section.querySelector('[data-bento-next]');

      if (!grid || !dotsBox) {
        return;
      }

      const cards = Array.from(grid.querySelectorAll('.mc-magic-bento__card'));

      if (cards.length < 2) {
        return;
      }

      let activeIndex = 0;
      let scrollTicking = false;

      const dots = cards.map((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mc-magic-bento__dot';
        dot.setAttribute('aria-label', `Go to card ${index + 1}`);
        dot.addEventListener('click', () => {
          scrollToCard(index);
        });
        dotsBox.appendChild(dot);
        return dot;
      });

      const setActive = (index) => {
        activeIndex = index;
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      const scrollToCard = (index) => {
        const clampedIndex = Math.max(0, Math.min(cards.length - 1, index));
        // 基于卡片实际位置计算居中目标，兼容首尾卡片的外边距
        const gridRect = grid.getBoundingClientRect();
        const cardRect = cards[clampedIndex].getBoundingClientRect();
        const cardLeftInContent = cardRect.left - gridRect.left + grid.scrollLeft;
        const target = cardLeftInContent - (grid.clientWidth - cardRect.width) / 2;
        grid.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        setActive(clampedIndex);
      };

      grid.addEventListener('scroll', () => {
        if (scrollTicking) {
          return;
        }

        scrollTicking = true;
        window.requestAnimationFrame(() => {
          // 以距离容器中心最近的卡片作为激活项，兼容 center 吸附
          const gridRect = grid.getBoundingClientRect();
          const containerMid = gridRect.left + gridRect.width / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;

          cards.forEach((card, cardIndex) => {
            const cardRect = card.getBoundingClientRect();
            const distance = Math.abs(cardRect.left + cardRect.width / 2 - containerMid);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = cardIndex;
            }
          });

          if (closestIndex !== activeIndex) {
            setActive(closestIndex);
          }

          scrollTicking = false;
        });
      }, { passive: true });

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          scrollToCard(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          scrollToCard(activeIndex + 1);
        });
      }

      setActive(0);
    };

    const initSection = (section) => {
      if (!section || initializedSections.has(section)) {
        return;
      }

      initializedSections.add(section);
      initCardInteractions(section);
      initMobileCarousel(section);
    };

    const initAll = (root = document) => {
      if (root instanceof Element && root.matches(SECTION_SELECTOR)) {
        initSection(root);
      }

      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
        initSection(section);
      });
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-component"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let scopedPageStyleCounter = 0;

    function getContainers(scope) {
      return Array.from(scope.querySelectorAll('.tab-component-section .product-tab-component'));
    }

    function getTabSequence(container) {
      return Array.from(container.querySelectorAll('.tab-content-item')).map((item) => item.dataset.tabContent).filter(Boolean);
    }

    function isDesktopSplitMode() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    function getTabContentBody(content) {
      return content.querySelector('.tab-content-body');
    }

    function getTabToggleWrapper(content) {
      return content.querySelector('[data-tab-toggle-wrapper]');
    }

    function getTabToggleButton(content) {
      return content.querySelector('[data-tab-toggle-button]');
    }

    function queueContentToggleUpdate(content) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateContentToggle(content);
        });
      });
    }

    function setTabToggleState(content, expanded) {
      const button = getTabToggleButton(content);
      const wrapper = getTabToggleWrapper(content);

      if (!button || !wrapper) return;

      const label = button.querySelector('.tab-content-toggle-label');
      const viewMoreLabel = label ? label.dataset.viewMoreLabel : '';
      const viewLessLabel = label ? label.dataset.viewLessLabel : '';

      content.dataset.toggleExpanded = expanded ? 'true' : 'false';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      if (label) {
        label.textContent = expanded ? viewLessLabel : viewMoreLabel;
      }

      wrapper.classList.toggle('is-collapsed', !expanded);
    }

    function updateContentToggle(content) {
      if (!content || !content.classList.contains('active')) return;

      const container = content.closest('.product-tab-component');
      const wrapper = getTabToggleWrapper(content);
      const button = getTabToggleButton(content);

      if (!container || !wrapper || !button) return;
      if (container.dataset.enableContentToggle !== 'true') return;

      const collapsedHeight = parseInt(container.dataset.collapsedHeight, 10) || 420;

      wrapper.classList.remove('is-collapsed');
      button.hidden = true;
      const contentHeight = wrapper.scrollHeight;

      if (contentHeight <= collapsedHeight + 1) {
        content.dataset.toggleExpanded = 'false';
        button.setAttribute('aria-expanded', 'false');
        return;
      }

      button.hidden = false;
      setTabToggleState(content, content.dataset.toggleExpanded === 'true');
    }

    function toggleTabContent(button) {
      const content = button.closest('.tab-content-item');

      if (!content) return;

      setTabToggleState(content, content.dataset.toggleExpanded !== 'true');
      queueContentToggleUpdate(content);
    }

    function setSplitRowTone(row, rowIndex) {
      row.classList.remove('row-tone-light', 'row-tone-muted');
      row.classList.add(rowIndex % 2 === 0 ? 'row-tone-muted' : 'row-tone-light');
    }

    function cloneSplitRow(row, rowIndex) {
      const clonedRow = row.cloneNode(true);
      setSplitRowTone(clonedRow, rowIndex);

      clonedRow.querySelectorAll('td, th').forEach((cell) => {
        cell.removeAttribute('width');
        cell.style.width = '';
      });

      return clonedRow;
    }

    function createPlaceholderRow(rowIndex) {
      const placeholderRow = document.createElement('tr');
      const placeholderCell = document.createElement('td');

      placeholderCell.colSpan = 2;
      placeholderCell.className = 'split-placeholder-cell';
      placeholderCell.textContent = '—';
      placeholderRow.appendChild(placeholderCell);

      setSplitRowTone(placeholderRow, rowIndex);

      return placeholderRow;
    }

    function buildSplitTable(baseTable, rows, rowCount, tableSide) {
      const splitTable = baseTable.cloneNode(false);
      const tbody = document.createElement('tbody');

      splitTable.classList.add('split-table-half', `split-table-half--${tableSide}`);
      splitTable.removeAttribute('data-column-split-applied');
      splitTable.appendChild(tbody);

      rows.forEach((row, rowIndex) => {
        tbody.appendChild(cloneSplitRow(row, rowIndex + 1));
      });

      if (rows.length < rowCount) {
        tbody.appendChild(createPlaceholderRow(rowCount));
      }

      return splitTable;
    }

    function applyColumnSplit(table) {
      if (!table || table.dataset.columnSplitApplied === 'true') return;

      const rows = Array.from(table.querySelectorAll('tr'));
      if (rows.length < 2) return;

      const splitIndex = Math.ceil(rows.length / 2);
      const rowCount = splitIndex;
      const leftRows = rows.slice(0, splitIndex);
      const rightRows = rows.slice(splitIndex);
      const wrapper = document.createElement('div');
      const leftTable = buildSplitTable(table, leftRows, rowCount, 'left');
      const rightTable = buildSplitTable(table, rightRows, rowCount, 'right');

      wrapper.className = 'tab-split-table-grid';
      wrapper.appendChild(leftTable);
      wrapper.appendChild(rightTable);

      table.dataset.columnSplitApplied = 'true';
      table.replaceWith(wrapper);
    }

    function syncSplitTableHeights(scope) {
      scope.querySelectorAll('.tab-split-table-grid').forEach((grid) => {
        const leftRows = Array.from(grid.querySelectorAll('.split-table-half--left tr'));
        const rightRows = Array.from(grid.querySelectorAll('.split-table-half--right tr'));
        const rowCount = Math.max(leftRows.length, rightRows.length);

        leftRows.forEach((row) => {
          row.style.height = '';
          row.querySelectorAll('td, th').forEach((cell) => {
            cell.style.height = '';
          });
        });

        rightRows.forEach((row) => {
          row.style.height = '';
          row.querySelectorAll('td, th').forEach((cell) => {
            cell.style.height = '';
          });
        });

        for (let index = 0; index < rowCount; index += 1) {
          const leftRow = leftRows[index];
          const rightRow = rightRows[index];
          const leftHeight = leftRow ? leftRow.getBoundingClientRect().height : 0;
          const rightHeight = rightRow ? rightRow.getBoundingClientRect().height : 0;
          const syncedHeight = Math.max(leftHeight, rightHeight, 64);

          [leftRow, rightRow].forEach((row) => {
            if (!row) return;

            row.style.height = `${syncedHeight}px`;
            row.querySelectorAll('td, th').forEach((cell) => {
              cell.style.height = `${syncedHeight}px`;
            });
          });
        }
      });
    }

    function queueSplitTableHeightsSync(scope) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          syncSplitTableHeights(scope);
        });
      });
    }

    function cacheOriginalContent(content) {
      const body = getTabContentBody(content);
      if (!body) return null;

      if (typeof content.__originalMarkup !== 'string') {
        content.__originalMarkup = body.innerHTML;
      }

      return body;
    }

    function restoreOriginalContent(content) {
      const body = cacheOriginalContent(content);
      if (!body) return null;

      body.innerHTML = content.__originalMarkup;
      return body;
    }

    function processSplitContent(content) {
      const body = cacheOriginalContent(content);
      if (!body) return;

      if (!isDesktopSplitMode()) {
        if (content.dataset.splitView !== 'mobile') {
          restoreOriginalContent(content);
        }

        content.dataset.splitView = 'mobile';
        content.classList.remove('is-processing');
        queueContentToggleUpdate(content);
        return;
      }

      content.classList.add('is-processing');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const desktopBody = restoreOriginalContent(content);

          if (!desktopBody) {
            content.classList.remove('is-processing');
            return;
          }

          desktopBody.querySelectorAll('table').forEach((table) => {
            if (!table.closest('.tab-split-table-grid')) {
              applyColumnSplit(table);
            }
          });

          content.dataset.splitView = 'desktop';
          content.classList.remove('is-processing');
          queueSplitTableHeightsSync(content);
          queueContentToggleUpdate(content);
        });
      });
    }

    function normalizeSplitTables(container) {
      container.querySelectorAll('.tab-content-item[data-column-split="true"]').forEach((content) => {
        processSplitContent(content);
      });
    }

    function usesDefaultTabTableStyle(content) {
      return content && content.dataset.tabUseTableStyle === 'true';
    }

    function isGeometryLayout(content) {
      return content && content.dataset.layoutMode === 'geometry_spec';
    }

    function isStyledTableLayout(content) {
      return content && content.dataset.layoutMode === 'styled_table';
    }

    function shouldScopePageInlineStyles(content) {
      if (!content) {
        return false;
      }

      if (isStyledTableLayout(content)) {
        return false;
      }

      if (isGeometryLayout(content)) {
        return content.dataset.geometryUseTableStyle === 'false';
      }

      return content.dataset.tabUseTableStyle === 'false';
    }

    function ensurePageStyleScopeId(content) {
      if (!content) {
        return '';
      }

      if (!content.id) {
        scopedPageStyleCounter += 1;
        content.id = `tab-content-style-scope-${scopedPageStyleCounter}`;
      }

      return `#${content.id}`;
    }

    function serializeScopedCssRules(rules, scopeSelector) {
      let output = '';

      rules.forEach((rule) => {
        if (rule.type === CSSRule.STYLE_RULE) {
          const selectors = rule.selectorText
            .split(',')
            .map((selector) => `${scopeSelector} ${selector.trim()}`)
            .join(', ');

          output += `${selectors} { ${rule.style.cssText} }\n`;
          return;
        }

        if (rule.type === CSSRule.MEDIA_RULE) {
          output += `@media ${rule.conditionText} {\n${serializeScopedCssRules(Array.from(rule.cssRules || []), scopeSelector)}}\n`;
          return;
        }

        if (rule.type === CSSRule.SUPPORTS_RULE) {
          output += `@supports ${rule.conditionText} {\n${serializeScopedCssRules(Array.from(rule.cssRules || []), scopeSelector)}}\n`;
          return;
        }

        output += `${rule.cssText}\n`;
      });

      return output;
    }

    function buildScopedCssText(cssText, scopeSelector) {
      if (!cssText || !scopeSelector) {
        return '';
      }

      const parser = document.createElement('style');
      parser.textContent = cssText;
      document.head.appendChild(parser);

      try {
        if (parser.sheet) {
          return serializeScopedCssRules(Array.from(parser.sheet.cssRules || []), scopeSelector);
        }
      } catch (error) {
        return cssText.replace(/(^|})\s*([^@}{][^{}]*)\{/g, (match, boundary, selectors) => {
          const scopedSelectors = selectors
            .split(',')
            .map((selector) => `${scopeSelector} ${selector.trim()}`)
            .join(', ');

          return `${boundary}\n${scopedSelectors} {`;
        });
      } finally {
        parser.remove();
      }

      parser.remove();
      return '';
    }

    function applyScopedInlineStyles(content) {
      if (!shouldScopePageInlineStyles(content)) {
        return;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return;
      }

      body.querySelectorAll('style[data-scoped-page-style-clone]').forEach((styleNode) => {
        styleNode.remove();
      });

      const scopeSelector = ensurePageStyleScopeId(content);
      const sourceStyles = Array.from(body.querySelectorAll('style:not([data-scoped-page-style-clone])'));

      sourceStyles.forEach((styleNode) => {
        const scopedCssText = buildScopedCssText(styleNode.textContent || '', scopeSelector);

        if (!scopedCssText.trim()) {
          return;
        }

        const scopedStyle = document.createElement('style');
        scopedStyle.setAttribute('data-scoped-page-style-clone', '');
        scopedStyle.textContent = scopedCssText;
        body.appendChild(scopedStyle);
      });
    }

    function getGeometrySourceMarkup(content) {
      if (!content) return '';

      if (typeof content.__geometrySourceMarkup === 'string' && content.__geometrySourceMarkup.trim() !== '') {
        return content.__geometrySourceMarkup;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return '';
      }

      const sourceMarkup = Array.from(body.querySelectorAll('[data-geometry-source]'))
        .map((element) => element.innerHTML.trim())
        .filter((markup) => markup !== '')
        .join('');

      if (sourceMarkup) {
        content.__geometrySourceMarkup = sourceMarkup;
        return content.__geometrySourceMarkup;
      }

      return '';
    }

    function getGeometryMediaMarkup(content) {
      if (!content) return '';

      if (typeof content.__geometryMediaMarkup === 'string') {
        return content.__geometryMediaMarkup;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return '';
      }

      const mediaTemplate = body.querySelector('[data-geometry-media-template]');
      content.__geometryMediaMarkup = mediaTemplate ? mediaTemplate.innerHTML.trim() : '';

      return content.__geometryMediaMarkup;
    }

    function getStyledTableSourceMarkup(content) {
      if (!content) return '';

      if (typeof content.__styledTableSourceMarkup === 'string' && content.__styledTableSourceMarkup.trim() !== '') {
        return content.__styledTableSourceMarkup;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return '';
      }

      const sourceMarkup = Array.from(body.querySelectorAll('[data-styled-table-source]'))
        .map((element) => element.innerHTML.trim())
        .filter((markup) => markup !== '')
        .join('');

      if (sourceMarkup) {
        content.__styledTableSourceMarkup = sourceMarkup;
        return content.__styledTableSourceMarkup;
      }

      return '';
    }

    function getStyledTableStyleMap(content) {
      if (!content) {
        return '';
      }

      if (typeof content.__styledTableStyleMap === 'string') {
        return content.__styledTableStyleMap;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return '';
      }

      const styleMapNode = body.querySelector('[data-styled-table-style-map]');
      content.__styledTableStyleMap = styleMapNode ? styleMapNode.textContent.trim() : '';

      return content.__styledTableStyleMap;
    }

    function getStyledTableMediaMarkup(content) {
      if (!content) {
        return '';
      }

      if (typeof content.__styledTableMediaMarkup === 'string') {
        return content.__styledTableMediaMarkup;
      }

      const body = getTabContentBody(content);

      if (!body) {
        return '';
      }

      const mediaTemplate = body.querySelector('[data-styled-table-media-template]');
      content.__styledTableMediaMarkup = mediaTemplate ? mediaTemplate.innerHTML.trim() : '';

      return content.__styledTableMediaMarkup;
    }

    function isMeaningfulNode(node) {
      if (!node) {
        return false;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim() !== '';
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      if (node.matches('script')) {
        return false;
      }

      return true;
    }

    function getTopLevelNode(root, node) {
      let current = node;

      while (current && current.parentNode !== root) {
        current = current.parentNode;
      }

      return current;
    }

    function getMeaningfulChildNodes(node) {
      return Array.from(node.childNodes || []).filter(isMeaningfulNode);
    }

    function getGeometryIndexLabel(index, mode) {
      if (mode === 'numbers') {
        return String(index + 1);
      }

      if (mode === 'letters') {
        let current = index;
        let label = '';

        do {
          label = String.fromCharCode(65 + (current % 26)) + label;
          current = Math.floor(current / 26) - 1;
        } while (current >= 0);

        return label;
      }

      return '';
    }

    function styledTableColumnLabelToIndex(label) {
      return String(label || '')
        .trim()
        .toUpperCase()
        .split('')
        .reduce((total, character) => (total * 26) + (character.charCodeAt(0) - 64), 0);
    }

    function styledTableColumnIndexToLabel(index) {
      let current = Number(index) || 0;
      let label = '';

      while (current > 0) {
        current -= 1;
        label = String.fromCharCode(65 + (current % 26)) + label;
        current = Math.floor(current / 26);
      }

      return label;
    }

    function parseStyledTableCellReference(reference) {
      const match = String(reference || '').trim().toUpperCase().match(/^([A-Z]+)(\d+)$/);

      if (!match) {
        return null;
      }

      const column = styledTableColumnLabelToIndex(match[1]);
      const row = parseInt(match[2], 10);

      if (column < 1 || row < 1) {
        return null;
      }

      return {
        row,
        column
      };
    }

    function normalizeStyledTablePreset(preset) {
      const normalizedPreset = String(preset || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/-/g, '_');

      if (['base', 'header', 'accent', 'highlight', 'muted'].includes(normalizedPreset)) {
        return normalizedPreset;
      }

      return '';
    }

    function parseStyledTableSelector(selectorText) {
      const normalizedSelector = String(selectorText || '').trim();

      if (!normalizedSelector) {
        return [];
      }

      let selector = normalizedSelector;
      let tableIndex = null;
      const tableMatch = selector.match(/^(?:T|TABLE)\s*(\d+)\s*!\s*(.+)$/i);

      if (tableMatch) {
        tableIndex = parseInt(tableMatch[1], 10);
        selector = tableMatch[2].trim();
      }

      if (!selector) {
        return [];
      }

      if (/^(?:\*|all)$/i.test(selector)) {
        return [{ type: 'all', tableIndex }];
      }

      const rowMatch = selector.match(/^ROW\s*:\s*(\d+)(?:\s*-\s*(\d+))?$/i);
      if (rowMatch) {
        const rowStart = parseInt(rowMatch[1], 10);
        const rowEnd = parseInt(rowMatch[2] || rowMatch[1], 10);

        if (rowStart > 0 && rowEnd > 0) {
          return [{
            type: 'row',
            tableIndex,
            rowStart: Math.min(rowStart, rowEnd),
            rowEnd: Math.max(rowStart, rowEnd)
          }];
        }
      }

      const columnMatch = selector.match(/^COL\s*:\s*([A-Z]+)(?:\s*-\s*([A-Z]+))?$/i);
      if (columnMatch) {
        const columnStart = styledTableColumnLabelToIndex(columnMatch[1]);
        const columnEnd = styledTableColumnLabelToIndex(columnMatch[2] || columnMatch[1]);

        if (columnStart > 0 && columnEnd > 0) {
          return [{
            type: 'column',
            tableIndex,
            columnStart: Math.min(columnStart, columnEnd),
            columnEnd: Math.max(columnStart, columnEnd)
          }];
        }
      }

      const rangeMatch = selector.match(/^([A-Z]+\d+)\s*:\s*([A-Z]+\d+)$/i);
      if (rangeMatch) {
        const start = parseStyledTableCellReference(rangeMatch[1]);
        const end = parseStyledTableCellReference(rangeMatch[2]);

        if (start && end) {
          return [{
            type: 'range',
            tableIndex,
            rowStart: Math.min(start.row, end.row),
            rowEnd: Math.max(start.row, end.row),
            columnStart: Math.min(start.column, end.column),
            columnEnd: Math.max(start.column, end.column)
          }];
        }
      }

      const cellReference = parseStyledTableCellReference(selector);

      if (cellReference) {
        return [{
          type: 'cell',
          tableIndex,
          row: cellReference.row,
          column: cellReference.column
        }];
      }

      return [];
    }

    function parseStyledTableStyleMap(styleMapText) {
      const rules = [];

      String(styleMapText || '')
        .split(/\r?\n|;/)
        .forEach((line) => {
          const trimmedLine = line.trim();

          if (!trimmedLine || trimmedLine.startsWith('#') || trimmedLine.startsWith('//')) {
            return;
          }

          const separatorIndex = trimmedLine.indexOf('=');

          if (separatorIndex === -1) {
            return;
          }

          const selectorList = trimmedLine.slice(0, separatorIndex).trim();
          const preset = normalizeStyledTablePreset(trimmedLine.slice(separatorIndex + 1));

          if (!selectorList || !preset) {
            return;
          }

          selectorList.split(',').forEach((selector) => {
            parseStyledTableSelector(selector).forEach((parsedSelector) => {
              rules.push({
                ...parsedSelector,
                preset
              });
            });
          });
        });

      return rules;
    }

    function resetStyledTablePresetClasses(cell) {
      ['base', 'header', 'accent', 'highlight', 'muted'].forEach((preset) => {
        cell.classList.remove(`tab-managed-table__cell--${preset}`);
      });
    }

    function sanitizeStyledTable(table) {
      if (!table) {
        return;
      }

      table.querySelectorAll('colgroup').forEach((group) => {
        group.remove();
      });

      [table, ...Array.from(table.querySelectorAll('thead,tbody,tfoot,tr,th,td,col'))].forEach((element) => {
        element.removeAttribute('style');
        element.removeAttribute('class');
        element.removeAttribute('width');
        element.removeAttribute('height');
        element.removeAttribute('align');
        element.removeAttribute('valign');
        element.removeAttribute('bgcolor');
        element.removeAttribute('cellpadding');
        element.removeAttribute('cellspacing');
      });
    }

    function matchesStyledTableRule(cellMeta, rule) {
      if (!cellMeta || !rule) {
        return false;
      }

      if (rule.tableIndex && rule.tableIndex !== cellMeta.tableIndex) {
        return false;
      }

      const rowStart = cellMeta.row;
      const rowEnd = cellMeta.row + cellMeta.rowspan - 1;
      const columnStart = cellMeta.column;
      const columnEnd = cellMeta.column + cellMeta.colspan - 1;

      if (rule.type === 'all') {
        return true;
      }

      if (rule.type === 'row') {
        return rowStart <= rule.rowEnd && rowEnd >= rule.rowStart;
      }

      if (rule.type === 'column') {
        return columnStart <= rule.columnEnd && columnEnd >= rule.columnStart;
      }

      if (rule.type === 'range') {
        return rowStart <= rule.rowEnd
          && rowEnd >= rule.rowStart
          && columnStart <= rule.columnEnd
          && columnEnd >= rule.columnStart;
      }

      if (rule.type === 'cell') {
        return rowStart <= rule.row
          && rowEnd >= rule.row
          && columnStart <= rule.column
          && columnEnd >= rule.column;
      }

      return false;
    }

    function applyStyledTableClasses(cell, cellMeta, styleRules) {
      let appliedPreset = cell.tagName.toLowerCase() === 'th' ? 'header' : 'base';

      styleRules.forEach((rule) => {
        if (matchesStyledTableRule(cellMeta, rule)) {
          appliedPreset = rule.preset;
        }
      });

      resetStyledTablePresetClasses(cell);
      cell.classList.add(`tab-managed-table__cell--${appliedPreset}`);

      const condensedText = (cell.textContent || '').replace(/\s+/g, '');
      cell.classList.toggle('tab-managed-table__cell--divider', /^[—–-]+$/.test(condensedText));
    }

    function decorateStyledTable(table, tableIndex, styleRules) {
      if (!table) {
        return;
      }

      table.classList.add('tab-managed-table__table');
      table.dataset.styledTableIndex = String(tableIndex);

      const occupiedMatrix = [];

      Array.from(table.rows || []).forEach((row, rowIndex) => {
        const matrixRow = occupiedMatrix[rowIndex] || (occupiedMatrix[rowIndex] = []);
        let columnCursor = 1;

        Array.from(row.cells || []).forEach((cell) => {
          while (matrixRow[columnCursor]) {
            columnCursor += 1;
          }

          const rowspan = Math.max(parseInt(cell.getAttribute('rowspan') || '1', 10), 1);
          const colspan = Math.max(parseInt(cell.getAttribute('colspan') || '1', 10), 1);
          const address = `${styledTableColumnIndexToLabel(columnCursor)}${rowIndex + 1}`;
          const cellMeta = {
            tableIndex,
            row: rowIndex + 1,
            column: columnCursor,
            rowspan,
            colspan,
            address
          };

          cell.classList.add('tab-managed-table__cell');
          cell.dataset.styledTableAddress = address;
          cell.dataset.styledTableRow = String(cellMeta.row);
          cell.dataset.styledTableColumn = String(cellMeta.column);
          cell.dataset.styledTableColumnLabel = styledTableColumnIndexToLabel(columnCursor);
          cell.dataset.styledTableColspan = String(colspan);
          cell.dataset.styledTableRowspan = String(rowspan);
          applyStyledTableClasses(cell, cellMeta, styleRules);

          for (let rowOffset = 0; rowOffset < rowspan; rowOffset += 1) {
            const occupiedRow = occupiedMatrix[rowIndex + rowOffset] || (occupiedMatrix[rowIndex + rowOffset] = []);

            for (let columnOffset = 0; columnOffset < colspan; columnOffset += 1) {
              occupiedRow[columnCursor + columnOffset] = true;
            }
          }

          columnCursor += colspan;
        });
      });
    }

    function processStyledTableContent(content) {
      const body = getTabContentBody(content);
      const sourceMarkup = getStyledTableSourceMarkup(content);
      const mediaMarkup = getStyledTableMediaMarkup(content);

      if (!body || !sourceMarkup) {
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = sourceMarkup;

      const styleRules = parseStyledTableStyleMap(getStyledTableStyleMap(content));
      let tableCount = 0;

      Array.from(temp.querySelectorAll('table')).forEach((table) => {
        tableCount += 1;
        sanitizeStyledTable(table);
        decorateStyledTable(table, tableCount, styleRules);

        const wrapper = document.createElement('div');
        wrapper.className = 'tab-managed-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });

      if (!tableCount) {
        queueContentToggleUpdate(content);
        return;
      }

      body.innerHTML = '';
      if (mediaMarkup) {
        const layout = document.createElement('div');
        const mediaColumn = document.createElement('div');
        const tableColumn = document.createElement('div');
        const imagePosition = content.dataset.styledTableImagePosition || 'left';

        layout.className = 'tab-styled-table-layout';
        if (imagePosition === 'top') {
          layout.classList.add('tab-styled-table-layout--top');
        }
        mediaColumn.className = 'tab-styled-table-layout__media';
        tableColumn.className = 'tab-styled-table-layout__table';
        mediaColumn.innerHTML = mediaMarkup;

        getMeaningfulChildNodes(temp).forEach((node) => {
          tableColumn.appendChild(node);
        });

        layout.appendChild(mediaColumn);
        layout.appendChild(tableColumn);
        body.appendChild(layout);
      } else {
        getMeaningfulChildNodes(temp).forEach((node) => {
          body.appendChild(node);
        });
      }
      applyScopedInlineStyles(content);
      queueContentToggleUpdate(content);
    }

    function decorateGeometryTable(table, indexMode) {
      if (!table) {
        return;
      }

      table.classList.add('tab-geometry-layout__table-element');

      if (indexMode === 'none') {
        table.classList.remove('tab-geometry-layout__table-element--has-index');
        return;
      }

      const rows = Array.from(table.rows).filter((row) => !row.closest('thead'));

      if (!rows.length) {
        return;
      }

      table.classList.add('tab-geometry-layout__table-element--has-index');

      rows.forEach((row, rowIndex) => {
        const firstCell = row.cells[0];

        if (!firstCell) {
          return;
        }

        const indexCell = document.createElement(firstCell.tagName.toLowerCase() === 'th' ? 'th' : 'td');
        const badge = document.createElement('span');

        indexCell.className = 'tab-geometry-layout__index-cell';
        badge.className = 'tab-geometry-layout__index-badge';
        badge.textContent = getGeometryIndexLabel(rowIndex, indexMode);
        indexCell.appendChild(badge);
        row.insertBefore(indexCell, firstCell);
      });
    }

    function processGeometryContent(content) {
      const body = getTabContentBody(content);
      const sourceMarkup = getGeometrySourceMarkup(content);
      const mediaMarkup = getGeometryMediaMarkup(content);

      if (!body || !sourceMarkup) {
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = sourceMarkup;

      const firstTable = temp.querySelector('table');

      if (!firstTable) {
        queueContentToggleUpdate(content);
        return;
      }

      const layout = document.createElement('div');
      const mediaColumn = document.createElement('div');
      const tableColumn = document.createElement('div');
      const indexMode = content.dataset.geometryIndexMode || 'none';

      layout.className = 'tab-geometry-layout';
      if (!mediaMarkup) {
        layout.classList.add('tab-geometry-layout--no-media');
      }
      mediaColumn.className = 'tab-geometry-layout__media';
      tableColumn.className = 'tab-geometry-layout__table';

      mediaColumn.innerHTML = mediaMarkup;
      if (mediaColumn.querySelector('.tab-geometry-layout__image--desktop') && mediaColumn.querySelector('.tab-geometry-layout__image--mobile')) {
        mediaColumn.querySelector('.tab-geometry-layout__image--desktop').classList.add('tab-geometry-layout__image--has-mobile');
      }

      decorateGeometryTable(firstTable, indexMode);
      getMeaningfulChildNodes(temp).forEach((node) => {
        tableColumn.appendChild(node);
      });
      layout.appendChild(mediaColumn);
      layout.appendChild(tableColumn);

      body.innerHTML = '';
      body.appendChild(layout);
      applyScopedInlineStyles(content);
      queueContentToggleUpdate(content);
    }

    function normalizeStructuredLayouts(container) {
      container.querySelectorAll('.tab-content-item').forEach((content) => {
        if (isGeometryLayout(content)) {
          processGeometryContent(content);
          return;
        }

        if (isStyledTableLayout(content)) {
          processStyledTableContent(content);
          return;
        }

        if (content.dataset.columnSplit === 'true') {
          if (!usesDefaultTabTableStyle(content)) {
            restoreOriginalContent(content);
            content.classList.remove('is-processing');
            applyScopedInlineStyles(content);
            queueContentToggleUpdate(content);
            return;
          }

          processSplitContent(content);
        }
      });
    }

    function executeInjectedScripts(scope) {
      scope.querySelectorAll('script').forEach((script) => {
        const replacement = document.createElement('script');

        Array.from(script.attributes).forEach((attribute) => {
          replacement.setAttribute(attribute.name, attribute.value);
        });

        replacement.textContent = script.textContent;
        script.replaceWith(replacement);
      });
    }

    function upgradeDeferredFileLinks(scope) {
      scope.querySelectorAll('a[href]').forEach((link) => {
        let url;

        try {
          url = new URL(link.href, window.location.origin);
        } catch (error) {
          return;
        }

        if (!url.pathname.includes('/cdn/shop/files/') && !url.pathname.includes('/s/files/') && !/\.(pdf|zip|doc|docx|xls|xlsx|ppt|pptx)$/i.test(url.pathname)) {
          return;
        }

        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      });
    }

    function extractDeferredPageMarkup(markup) {
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(markup, 'text/html');
      const mainContent = documentFragment.querySelector('#main') || documentFragment.querySelector('main[role="main"]');

      if (!mainContent) {
        return '';
      }

      const clonedMain = mainContent.cloneNode(true);

      clonedMain.querySelectorAll('[id]').forEach((element) => {
        const elementId = element.id || '';

        if (elementId.includes('__footer') || elementId.includes('gift_code')) {
          element.remove();
        }
      });

      return clonedMain.innerHTML.trim();
    }

    async function loadDeferredPageContent(content) {
      const host = content.querySelector('[data-deferred-page-host]');
      const container = content.closest('.product-tab-component');

      if (!host || host.dataset.loaded === 'true' || host.dataset.loading === 'true') {
        return;
      }

      const pageUrl = host.dataset.pageUrl;
      const target = host.querySelector('[data-deferred-page-target]');
      const status = host.querySelector('[data-deferred-page-status]');

      if (!pageUrl || !target || !status) {
        return;
      }

      host.dataset.loading = 'true';
      host.classList.add('is-loading');
      status.textContent = container.dataset.deferredLoadingLabel || '';

      try {
        const response = await fetch(pageUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const markup = await response.text();
        const extractedMarkup = extractDeferredPageMarkup(markup);

        if (!extractedMarkup) {
          throw new Error('No main content found');
        }

        target.innerHTML = extractedMarkup;
        if (target.hasAttribute('data-geometry-source')) {
          content.__geometrySourceMarkup = target.innerHTML;
        }

        if (target.hasAttribute('data-styled-table-source')) {
          content.__styledTableSourceMarkup = target.innerHTML;
        }

        upgradeDeferredFileLinks(target);
        target.hidden = false;
        status.hidden = true;
        host.dataset.loaded = 'true';
        executeInjectedScripts(target);
        if (isGeometryLayout(content)) {
          processGeometryContent(content);
        } else if (isStyledTableLayout(content)) {
          processStyledTableContent(content);
        } else if (content.dataset.columnSplit === 'true' && usesDefaultTabTableStyle(content)) {
          processSplitContent(content);
        } else {
          applyScopedInlineStyles(content);
          queueContentToggleUpdate(content);
        }
        queueSplitTableHeightsSync(content);
      } catch (error) {
        status.textContent = container.dataset.deferredErrorLabel || '';
        host.dataset.loaded = 'error';
      } finally {
        host.dataset.loading = 'false';
        host.classList.remove('is-loading');
      }
    }

    function updateMobileArrows(container, index) {
      const tabSequence = getTabSequence(container);
      const currentPosition = tabSequence.indexOf(index);
      const leftArrow = container.querySelector('.tab-arrow-left');
      const rightArrow = container.querySelector('.tab-arrow-right');

      if (!leftArrow || !rightArrow) return;

      if (currentPosition <= 0) {
        leftArrow.disabled = true;
        leftArrow.setAttribute('aria-disabled', 'true');
        leftArrow.querySelector('.icon-disabled').classList.remove('hidden');
        leftArrow.querySelector('.icon-active').classList.add('hidden');
      } else {
        leftArrow.disabled = false;
        leftArrow.setAttribute('aria-disabled', 'false');
        leftArrow.querySelector('.icon-disabled').classList.add('hidden');
        leftArrow.querySelector('.icon-active').classList.remove('hidden');
      }

      if (currentPosition === -1 || currentPosition >= tabSequence.length - 1) {
        rightArrow.disabled = true;
        rightArrow.setAttribute('aria-disabled', 'true');
        rightArrow.querySelector('.icon-disabled').classList.remove('hidden');
        rightArrow.querySelector('.icon-active').classList.add('hidden');
      } else {
        rightArrow.disabled = false;
        rightArrow.setAttribute('aria-disabled', 'false');
        rightArrow.querySelector('.icon-disabled').classList.add('hidden');
        rightArrow.querySelector('.icon-active').classList.remove('hidden');
      }
    }

    function replayTabTitleAnimation(titleItem, className) {
      if (!titleItem) {
        return;
      }

      const animationDuration = parseInt(titleItem.dataset.textAnimationDuration || '1000', 10);
      const timeoutKey = className === 'is-hover-animating' ? '__hoverAnimationTimeout' : '__clickAnimationTimeout';

      if (titleItem[timeoutKey]) {
        window.clearTimeout(titleItem[timeoutKey]);
      }

      titleItem.classList.remove(className);

      requestAnimationFrame(() => {
        titleItem.classList.add(className);
        titleItem[timeoutKey] = window.setTimeout(() => {
          titleItem.classList.remove(className);
          titleItem[timeoutKey] = null;
        }, animationDuration);
      });
    }

    function switchTab(container, index, triggerTitle) {
      if (!container) return;
      const shouldLockHoverState = !!triggerTitle;

      container.querySelectorAll('.tab-title-item').forEach((title) => {
        const isActive = title.dataset.tab === index;
        title.classList.remove('is-click-selected');
        title.classList.toggle('active', isActive);

        if (isActive) {
          if (shouldLockHoverState && title === triggerTitle) {
            title.classList.add('is-click-selected');
          }

          title.classList.remove('is-animating');
          replayTabTitleAnimation(title, 'is-animating');
        } else {
          title.classList.remove('is-animating');
          title.classList.remove('is-hover-animating');
        }
      });

      container.querySelectorAll('.mobile-title-item').forEach((title) => {
        title.classList.toggle('hidden', title.dataset.tab !== index);
      });

      container.querySelectorAll('.tab-content-item').forEach((content) => {
        content.classList.toggle('active', content.dataset.tabContent === index);
      });

      updateMobileArrows(container, index);
      const activeContent = container.querySelector(`.tab-content-item[data-tab-content="${index}"]`);

      if (activeContent) {
        Promise.resolve(loadDeferredPageContent(activeContent)).finally(() => {
          if (isGeometryLayout(activeContent)) {
            processGeometryContent(activeContent);
          } else if (isStyledTableLayout(activeContent)) {
            processStyledTableContent(activeContent);
          } else if (activeContent.dataset.columnSplit === 'true' && usesDefaultTabTableStyle(activeContent)) {
            processSplitContent(activeContent);
          } else {
            queueSplitTableHeightsSync(container);
            queueContentToggleUpdate(activeContent);
          }
        });
      }
    }

    function goToSiblingTab(container, direction) {
      const activeContent = container.querySelector('.tab-content-item.active');
      if (!activeContent) return;

      const tabSequence = getTabSequence(container);
      const currentPosition = tabSequence.indexOf(activeContent.dataset.tabContent);
      const nextPosition = currentPosition + direction;

      if (nextPosition >= 0 && nextPosition < tabSequence.length) {
        switchTab(container, tabSequence[nextPosition]);
      }
    }

    function prepareAnimatedTabTitles(container) {
      const charTransitionDuration = 250;
      const charDelayStep = 14;

      container.querySelectorAll('.tab-title-text').forEach((label) => {
        if (label.dataset.animatedReady === 'true') {
          return;
        }

        const text = (label.dataset.text || label.textContent || '').trim();

        if (!text) {
          return;
        }

        label.dataset.animatedReady = 'true';
        label.dataset.text = text;
        label.setAttribute('aria-label', text);
        label.textContent = '';

        const titleItem = label.closest('.tab-title-item');
        const totalAnimationDuration = charTransitionDuration + Math.max(text.length - 1, 0) * charDelayStep;
        const sweepDuration = Math.max(Math.round(totalAnimationDuration / 4), 140);

        if (titleItem) {
          titleItem.dataset.textAnimationDuration = String(totalAnimationDuration);
          titleItem.style.setProperty('--tab-sweep-duration', `${sweepDuration}ms`);
        }

        const baseLayer = document.createElement('span');
        baseLayer.className = 'tab-title-text-base';
        baseLayer.setAttribute('aria-hidden', 'true');
        baseLayer.textContent = text;

        const animatedLayer = document.createElement('span');
        animatedLayer.className = 'tab-title-text-animated';
        animatedLayer.setAttribute('aria-hidden', 'true');
        animatedLayer.style.setProperty('--char-count', text.length);

        Array.from(text).forEach((character, index) => {
          const charWrap = document.createElement('span');
          charWrap.className = 'tab-title-text-char-wrap';

          const charNode = document.createElement('span');
          charNode.className = 'tab-title-text-char';
          charNode.style.setProperty('--char-index', index);
          charNode.textContent = character === ' ' ? '\u00A0' : character;
          charWrap.appendChild(charNode);
          animatedLayer.appendChild(charWrap);
        });

        label.append(baseLayer, animatedLayer);
      });
    }

    function bindTabTitleHoverState(container) {
      container.querySelectorAll('.tab-title-item').forEach((titleItem) => {
        if (titleItem.dataset.hoverStateBound === 'true') {
          return;
        }

        titleItem.dataset.hoverStateBound = 'true';
        titleItem.addEventListener('pointerenter', () => {
          if (titleItem.classList.contains('is-click-selected')) {
            return;
          }

          replayTabTitleAnimation(titleItem, 'is-hover-animating');
        });

        titleItem.addEventListener('pointerleave', () => {
          if (titleItem.__hoverAnimationTimeout) {
            window.clearTimeout(titleItem.__hoverAnimationTimeout);
            titleItem.__hoverAnimationTimeout = null;
          }

          titleItem.classList.remove('is-hover-animating');
          titleItem.classList.remove('is-click-selected');
        });
      });
    }

    function bindContainer(container) {
      if (container.dataset.tabComponentInitialized === 'true') return;

      container.dataset.tabComponentInitialized = 'true';

      container.querySelectorAll('.tab-title-item').forEach((title) => {
        title.addEventListener('click', () => {
          switchTab(container, title.dataset.tab, title);
        });
      });

      const leftArrow = container.querySelector('.tab-arrow-left');
      const rightArrow = container.querySelector('.tab-arrow-right');

      if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          goToSiblingTab(container, -1);
        });
      }

      if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          goToSiblingTab(container, 1);
        });
      }

      container.querySelectorAll('[data-tab-toggle-button]').forEach((button) => {
        button.addEventListener('click', () => {
          toggleTabContent(button);
        });
      });
    }

    function initialize(scope) {
      getContainers(scope).forEach((container) => {
        bindContainer(container);
        prepareAnimatedTabTitles(container);
        bindTabTitleHoverState(container);
        normalizeStructuredLayouts(container);

        const tabSequence = getTabSequence(container);
        if (!tabSequence.length) return;

        const activeContent = container.querySelector('.tab-content-item.active');
        const initialTab = activeContent ? activeContent.dataset.tabContent : container.dataset.firstTab || tabSequence[0];

        switchTab(container, initialTab);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    window.addEventListener('resize', () => {
      getContainers(document).forEach((container) => {
        normalizeStructuredLayouts(container);
        const activeContent = container.querySelector('.tab-content-item.active');

        if (activeContent) {
          queueContentToggleUpdate(activeContent);
        }
      });
    });

    window.addEventListener('load', () => {
      getContainers(document).forEach((container) => {
        queueSplitTableHeightsSync(container);
        const activeContent = container.querySelector('.tab-content-item.active');

        if (activeContent) {
          queueContentToggleUpdate(activeContent);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
